import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import './ProductDetail.css';

// Smart Home Hub images
import hubM200 from '../../assets/smarthubs/hub-m200-transparent-2.png';
import hubM200Hero from '../../assets/smarthubs/hubm200/hero.png';
import hubM200Feature from '../../assets/smarthubs/hubm200/m200-7.png';
import hubM100 from '../../assets/smarthubs/hub-m100-product-picture-1.png';
import hubM100Hero from '../../assets/smarthubs/hub m100/hero.png';
import hubM100Feature from '../../assets/smarthubs/hub m100/hub-m100-3.png';
import hubM3 from '../../assets/smarthubs/M3-分类页白底图-2048x2048.png';
import hubM3Hero from '../../assets/smarthubs/hub m 3/hero.png';
import hubM3Feature from '../../assets/smarthubs/hub m 3/2560-Hub-M3_01_05-2048x1362.jpg';
import hubM2 from '../../assets/smarthubs/Hub-M2.png';
import hubE1 from '../../assets/smarthubs/HUBE1.png';
import hubM1SGen2 from '../../assets/smarthubs/Hub-M1S-Gen-2.png';
import cameraHubG2H from '../../assets/smarthubs/camera-hub-g2h-1.png';
import cameraHubG2HPro from '../../assets/smarthubs/Camera-Hub-G2H-Pro.png';
import cameraHubG3 from '../../assets/smarthubs/Camera-Hub-G3.png';
import aqaraHub from '../../assets/smarthubs/aqara-hub-1.png';
import aqaraHub2 from '../../assets/smarthubs/aqara-hub-1 (1).png';

// Legacy category images
import hubsImg from '../../assets/products/hubs.png';
import switchesImg from '../../assets/products/switches.png';
import bulbsImg from '../../assets/products/bulbs.png';
import sensorsImg from '../../assets/products/sensors.png';
import camerasImg from '../../assets/products/cameras.png';
import remotesImg from '../../assets/products/remotes.png';
import speakersImg from '../../assets/products/speakers.png';

// Smart Door Lock images
import smartLockB50 from '../../assets/smartdoorlocks/Smart Lock B50.png';
import smartLockB50Hero from '../../assets/smartdoorlocks/productpage/smartlock b50/hero.png';
import smartLockB50Feature1 from '../../assets/smartdoorlocks/productpage/smartlock b50/smart-lock-b50-2.png';
import smartLockB50Feature2 from '../../assets/smartdoorlocks/productpage/smartlock b50/smart-lock-b50-3.png';
import smartLockU200Lite from '../../assets/smartdoorlocks/Smart Lock U200 Lite.png';
import smartLockU200LiteHero from '../../assets/smartdoorlocks/productpage/smartlock u200 lite/hero.png';
import smartLockU200LitePlatProduct from '../../assets/smartdoorlocks/productpage/smartlock u200 lite/plat-product.png';
import smartLockU300 from '../../assets/smartdoorlocks/Smart Lock U300.png';
import smartLockU300Hero from '../../assets/smartdoorlocks/productpage/smartlock u300/hero.jpg';
import smartLockU300Feature from '../../assets/smartdoorlocks/productpage/smartlock u300/6-3.png';
import smartLockU200 from '../../assets/smartdoorlocks/Smart Lock U200.png';
import smartLockU200Hero from '../../assets/smartdoorlocks/productpage/smartlock u200/hero.png';
import smartLockU200Feature from '../../assets/smartdoorlocks/productpage/smartlock u200/2560-smart-lock-U200_11-scaled.jpg';
import smartLockU50 from '../../assets/smartdoorlocks/Smart Lock U50.png';
import smartLockU50HeroVideo from '../../assets/smartdoorlocks/productpage/smartlock u50/hero.mp4';
import smartLockU50Feature from '../../assets/smartdoorlocks/productpage/smartlock u50/u501.png';
import smartLockU100 from '../../assets/smartdoorlocks/Smart Lock U100.png';
import smartLockU100Hero from '../../assets/smartdoorlocks/productpage/smartlock u100/hero.png';
import smartLockU100Feature from '../../assets/smartdoorlocks/productpage/smartlock u100/Group-3-1-2048x974.png';
import smartLockD200i from '../../assets/smartdoorlocks/Smart Lock D200i.jpg';
import smartLockD200iHero from '../../assets/smartdoorlocks/productpage/smartlock d200i/hero.jpg';
import smartLockD200iFeature from '../../assets/smartdoorlocks/productpage/smartlock d200i/maxresdefault.jpg';
import smartLockU400 from '../../assets/smartdoorlocks/smart Lock U400.png';
import smartLockU400HeroVideo from '../../assets/smartdoorlocks/productpage/smartlock u400/hero.mp4';
import smartLockU400FeatureVideo from '../../assets/smartdoorlocks/productpage/smartlock u400/hro.mp4';
import smartLockA100 from '../../assets/smartdoorlocks/Smart-Door-Lock-A100-Zigbee.png';
import smartLockA100Hero from '../../assets/smartdoorlocks/productpage/smartlock a100/hero.png';
import smartLockA100Feature from '../../assets/smartdoorlocks/productpage/smartlock a100/product.png';
import smartLockD100 from '../../assets/smartdoorlocks/Smart-Door-Lock-D100-Zigbee.png';
import smartLockD100Hero from '../../assets/smartdoorlocks/productpage/smartlock d100/hero.png';
import smartLockD100Feature from '../../assets/smartdoorlocks/productpage/smartlock d100/Untitled-4-3.png';
import smartLockN100 from '../../assets/smartdoorlocks/Smart-Door-Lock-N100-Zigbee.png';
import smartLockN100Hero from '../../assets/smartdoorlocks/productpage/smartlock n100/hero.jpg';
import smartLockN100Feature from '../../assets/smartdoorlocks/productpage/smartlock n100/Untitled-1-1024x943.png';

// Smart Sensor images
import presenceFP300 from '../../assets/smartsensors/Presence Multi-Sensor FP300.png';
import vibrationT1 from '../../assets/smartsensors/Vibration Sensor T1.jpg';
import climateW100 from '../../assets/smartsensors/Climate Sensor W100.png';
import presenceFP1E from '../../assets/smartsensors/Presence Sensor FP1E.png';
import motionLightP2 from '../../assets/smartsensors/Motion and Light Sensor P2.png';
import doorWindowP2 from '../../assets/smartsensors/Door and Window Sensor P2.png';
import presenceFP2 from '../../assets/smartsensors/Presence Sensor FP2.png';
import motionP1 from '../../assets/smartsensors/Motion Sensor P1.png';
import waterLeak from '../../assets/smartsensors/Water Leak Sensor.png';
import tempHumidity from '../../assets/smartsensors/Temperature and Humidity Sensor.png';
import doorWindowT1 from '../../assets/smartsensors/Door and Window Sensor T1.png';
import doorWindowSensor from '../../assets/smartsensors/Door-and-Window-Sensor.png';
import motionSensor from '../../assets/smartsensors/Motion Sensor.png';
import smartGasDetector from '../../assets/smartsensors/Smart Gas Detector.png';
import tempHumidityT1 from '../../assets/smartsensors/Temperature and Humidity Sensor T1.png';
import vibrationSensor from '../../assets/smartsensors/Vibration Sensor.png';
import tvocMonitor from '../../assets/smartsensors/TVOC Air Quality Monitor.png';
import waterLeakT1 from '../../assets/smartsensors/Water Leak Sensor T1.png';

// Smart Controller images
import cubeT1Pro from '../../assets/smartcontrollers/Cube T1 Pro.png';
import smartPlug from '../../assets/smartcontrollers/Smart Plug(US Version).png';
import cube from '../../assets/smartcontrollers/Cube.png';
import dimmerSwitchH2EU from '../../assets/smartcontrollers/Dimmer Switch H2 EU.jpg';
import dimmerSwitchH2US from '../../assets/smartcontrollers/Dimmer Switch H2 US.png';
import dualRelayT2 from '../../assets/smartcontrollers/Dual Relay Module T2.png';
import floorThermostatW500 from '../../assets/smartcontrollers/Floor Heating Thermostat W500.png';
import radiatorE1 from '../../assets/smartcontrollers/Radiator Thermostat E1.png';
import radiatorW600 from '../../assets/smartcontrollers/Radiator Thermostat W600.png';
import shutterSwitchH2EU from '../../assets/smartcontrollers/Shutter Switch H2 EU.png';
import singleSwitchT1NoNeutral from '../../assets/smartcontrollers/Single Switch Module T1 (No Neutral).png';
import singleSwitchT1WithNeutral from '../../assets/smartcontrollers/Single Switch Module T1 (With Neutral).png';
import smartPetFeederC1 from '../../assets/smartcontrollers/Smart Pet Feeder C1.png';
import smartPlugEU from '../../assets/smartcontrollers/Smart-PlugEU-Version.png';
import thermostatW400 from '../../assets/smartcontrollers/Thermostat W400.png';
import valveControllerT1 from '../../assets/smartcontrollers/Valve Controller T1.jpg';
import wallOutletH2EU from '../../assets/smartcontrollers/Wall Outlet H2 EU.jpg';
import wallOutletH2UK from '../../assets/smartcontrollers/Wall Outlet H2 UK.png';
import wirelessMiniSwitchT1 from '../../assets/smartcontrollers/Wireless Mini Switch T1.png';
import wirelessMiniSwitch from '../../assets/smartcontrollers/Wireless Mini Switch.png';
import smart20ASwitchH1 from '../../assets/smartcontrollers/Smart 20A Switch H1 (SEA Version）.png';
import lightSwitchH2US from '../../assets/smartcontrollers/Light Switch H2 US.png';
import lightSwitchH2Horizontal from '../../assets/smartcontrollers/Light Switch H2 Horizontal.png';
import smartWallSwitchNeutral from '../../assets/smartcontrollers/Smart Wall Switch (With Neutral).png';
import smartWallSwitchNoNeutral from '../../assets/smartcontrollers/Smart Wall Switch (No Neutral).png';
import smartWallSwitchH1EUNoNeutral from '../../assets/smartcontrollers/Smart Wall Switch H1 EU (No Neutral).png';

// Switch images
import touchscreenDialV1EU from '../../assets/smartcontrollers/Touchscreen Dial V1 EU.jpg';
import touchscreenDialV1EUHero from '../../assets/smart switches/touchscreen dial v1eu/hero.png';
import touchscreenDialV1EUFeature from '../../assets/smart switches/touchscreen dial v1eu/6-6.jpg';
import wallSwitchH1TripleNeutral from '../../assets/smartcontrollers/Smart Wall Switch H1 Triple Rocker (With Neutral).png';
import wallSwitchH1TripleNeutralHero from '../../assets/smart switches/wall switch h1 triple with neutral/hero.png';
import wallSwitchH1TripleNeutralFeature from '../../assets/smart switches/wall switch h1 triple with neutral/h1.png';
import wallSwitchZ1Pro from '../../assets/smartcontrollers/Smart Wall Switch Z1 Pro.png';
import wallSwitchZ1ProHero from '../../assets/smart switches/z1 pro/hero.jpg';
import wallSwitchZ1ProFeature from '../../assets/smart switches/z1 pro/Smart-Wall-Switch-Z1-Pro_10.jpg';
import wallSwitchH1EUNeutral from '../../assets/smartcontrollers/Smart Wall Switch H1 EU (With Neutral).png';
import wallSwitchH1EUNeutralHero from '../../assets/smart switches/h1 eu with neutral/hero.png';
import wallSwitchH1EUNeutralFeature from '../../assets/smart switches/h1 eu with neutral/2560-Aqara-Smart-Wall-Switch-H1-No-Neutral-_04.jpg';
import wallSwitchH1EUGrey from '../../assets/smartcontrollers/Smart Wall Switch H1 EU(No Neutral) - Grey.png';
import wallSwitchH1EUGreyHero from '../../assets/smart switches/h1 eu grey/hero.png';
import wallSwitchH1EUGreyFeature from '../../assets/smart switches/h1 eu grey/2560-Aqara-Smart-Wall-Switch-H1-No-Neutral-_04.jpg';
import wallSwitchH1TripleNoNeutral from '../../assets/smartcontrollers/Smart Wall Switch H1 Triple Rocker (No Neutral).png';
import wallSwitchH1TripleNoNeutralHero from '../../assets/smart switches/no neutral h1 triple/hero.png';
import panelSwitchS100 from '../../assets/smartcontrollers/Panel Switch S100.jpg';
import panelSwitchS100Hero from '../../assets/smart switches/s100/hero.png';
import panelSwitchS100Feature from '../../assets/smart switches/s100/panel-switch-panel-s100-1-1.jpg';
import magicSwitchS1E from '../../assets/smartcontrollers/Magic Switch S1E.png';
import magicSwitchS1EHero from '../../assets/smart switches/switch s1e/hero.png';
import magicSwitchS1EFeature from '../../assets/smart switches/switch s1e/Screenshot 2026-01-14 152455.png';
import magicpadS1Plus from '../../assets/smartcontrollers/MagicPad S1 Plus (SEA&ME Version).png';
import magicpadS1PlusHero from '../../assets/smart switches/magicpad/hero.png';
import magicpadS1PlusFeature from '../../assets/smart switches/magicpad/Screenshot 2026-01-14 150939.png';
import panelHubS1Plus from '../../assets/smartcontrollers/Panel Hub S1 Plus.jpg';
import panelHubS1PlusHero from '../../assets/smart switches/s1 plus/hero.png';
import panelHubS1PlusFeature from '../../assets/smart switches/s1 plus/1-5.jpg';
import lightSwitchH2EU from '../../assets/smartcontrollers/Light Switch H2 EU.jpg';
import lightSwitchH2EUHero from '../../assets/smart switches/switch h2 eu/hero.png';
import lightSwitchH2EUFeature from '../../assets/smart switches/switch h2 eu/3-4 (1).jpg';
import displaySwitchV1EU from '../../assets/smartcontrollers/Display Switch V1 EU.jpg';
import displaySwitchV1EUHero from '../../assets/smart switches/v1eu/hero.png';
import displaySwitchV1EUFeature from '../../assets/smart switches/v1eu/1-3.jpg';
import wirelessRemoteSwitchH1 from '../../assets/smartcontrollers/Wireless Remote Switch H1.png';
import wirelessRemoteSwitchH1Hero from '../../assets/smart switches/wireless remote switch h1/hero.png';
import wirelessRemoteSwitchH1Feature from '../../assets/smart switches/wireless remote switch h1/homekit-hero-lockup-large_2x.png';

// Smart Camera images
import doorbellG410 from '../../assets/smartcameras/Doorbell Camera Hub G410.png';
import cameraG100 from '../../assets/smartcameras/Camera G100.png';
import cameraY100 from '../../assets/smartcameras/Camera Protect Kit Y100.jpg';
import cameraG5Pro from '../../assets/smartcameras/Camera Hub G5 Pro.jpg';
import cameraE1 from '../../assets/smartcameras/Camera E1.png';
import doorbellG4 from '../../assets/smartcameras/Smart Video Doorbell G4.png';
import cameraG3 from '../../assets/smartcameras/Camera Hub G3.png';
import cameraG2HPro from '../../assets/smartcameras/Camera Hub G2H Pro.png';
import cameraG2H from '../../assets/smartcameras/Camera Hub G2H.png';

// Smart Lighting images
import ledBulbT2 from '../../assets/smartlights/LED Bulb T2.png';
import ledStripT1 from '../../assets/smartlights/LED Strip T1.webp';
import ledBulbT1 from '../../assets/smartlights/LED Bulb T1.png';
import ceilingT1M from '../../assets/smartlights/Ceiling Light T1M.png';
import spotlightT1 from '../../assets/smartlights/Spotlight T1.jpg';
import ledBulbTunableWhite from '../../assets/smartlights/LED Light Bulb (Tunable White).png';
import spotlightT2Lite from '../../assets/smartlights/Spotlight T2 Lite.png';
import spotlightT2Pro from '../../assets/smartlights/Spotlight T2 Pro.png';
import spotlightV1 from '../../assets/smartlights/Spotlight V1.png';
import trackFloodlightV1 from '../../assets/smartlights/Track Floodlight V1.png';
import trackGrilleV1 from '../../assets/smartlights/Track Grille Light V1.png';
import trackSpotlightV1 from '../../assets/smartlights/Track Spotlight V1.png';

// Smart Curtain images
import curtainC3 from '../../assets/smartcurtain/Curtain Controller C3.jpg';
import curtainSEA from '../../assets/smartcurtain/Curtain Controller(SEA Version).png';
import curtainE1Rod from '../../assets/smartcurtain/Curtain Driver E1 (Rod Version).png';
import curtainE1Track from '../../assets/smartcurtain/Curtain Driver E1 (Track Version).png';
import rollerT1S from '../../assets/smartcurtain/Roller Shade Controller T1S.jpg';
import rollerE1 from '../../assets/smartcurtain/Roller Shade Driver E1.png';
import rollerController from '../../assets/smartcurtain/Smart Roller Shade Controller.png';

interface Product {
  id: string;
  name: string;
  image: string;
  hero?: string;
  heroVideo?: string;
  featureVideo?: string;
  featureImages?: string[];
  contentSections?: { image: string; title: string; description: string; note?: string }[];
  description: string;
  fullDescription: string;
  features: string[];
  detailedFeatures?: { title: string; description: string }[];
  accessMethods?: { name: string; description: string }[];
  specifications: { label: string; value: string }[];
}

const ProductDetail: React.FC = () => {
  const { productId } = useParams<{ productId: string }>();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = React.useState<'overview' | 'access-methods'>('overview');

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Helper function to get category from product ID
  const getCategoryFromProductId = (id: string): string => {
    if (id.includes('aqara-hub') || (id.includes('hub') && !id.includes('panel-hub'))) return 'smart-home-hub';
    if (id.includes('lock')) return 'smart-door-locks';
    if (id.includes('sensor') || id.includes('motion') || id.includes('door-window') || 
        id.includes('presence') || id.includes('climate') || id.includes('water-leak') || 
        id.includes('temp-humidity') || id.includes('vibration') || id.includes('gas-detector') ||
        id.includes('tvoc')) return 'smart-home-sensor';
    // Switches category - check before smart-home-controller
    if (id.includes('touchscreen-dial') || id.includes('panel-switch') || id.includes('magic-switch') ||
        id.includes('magicpad') || id.includes('panel-hub') || id.includes('light-switch-h2-eu') ||
        id.includes('display-switch') || id.includes('wireless-remote-switch') ||
        (id.includes('wall-switch') && (id.includes('h1') || id.includes('z1')))) return 'switches';
    if (id.includes('cube') || id.includes('plug') || id.includes('dimmer') || id.includes('relay') ||
        id.includes('thermostat') || id.includes('radiator') || id.includes('shutter') ||
        id.includes('single-switch') || id.includes('pet-feeder') || id.includes('valve') ||
        id.includes('outlet') || id.includes('wireless-mini') || id.includes('20a-switch') ||
        id.includes('light-switch-h2-us')) return 'smart-home-controller';
    if (id.includes('camera') || id.includes('doorbell')) return 'smart-cameras';
    if (id.includes('bulb') || id.includes('strip') || id.includes('ceiling') || id.includes('spotlight') ||
        id.includes('track-')) return 'smart-lighting';
    if (id.includes('curtain') || id.includes('roller')) return 'smart-curtain';
    return 'smart-home-hub'; // default
  };

  const products: { [key: string]: Product } = {
    // Smart Home Hub Products
    'hub-m200': {
      id: 'hub-m200',
      name: 'Hub M200',
      image: hubM200,
      hero: hubM200Hero,
      featureImages: [hubM200Feature],
      description: 'One Hub. Matter & IR Control',
      fullDescription: 'The Hub M200 is the ultimate smart home control center, combining Matter support with IR control capabilities. Control all your smart devices and traditional IR appliances from a single hub.',
      features: [
        'Matter protocol support',
        'Built-in IR blaster for traditional devices',
        'Zigbee 3.0 connectivity',
        'Supports 128+ Zigbee devices',
        'Voice assistant compatible',
        'Local and cloud automation'
      ],
      specifications: [
        { label: 'Protocols', value: 'Matter, Zigbee 3.0, Wi-Fi' },
        { label: 'IR Control', value: 'Built-in IR blaster' },
        { label: 'Connectivity', value: 'Ethernet, Wi-Fi 2.4GHz/5GHz' },
        { label: 'Power', value: 'DC 5V/1A' }
      ]
    },
    'hub-m100': {
      id: 'hub-m100',
      name: 'Hub M100',
      image: hubM100,
      hero: hubM100Hero,
      featureImages: [hubM100Feature],
      description: 'Mighty Hub, Minimal Size',
      fullDescription: 'Compact yet powerful, the Hub M100 brings complete smart home control in a minimal footprint. Perfect for apartments and small spaces.',
      features: [
        'Ultra-compact design',
        'Zigbee 3.0 hub',
        'Supports up to 64 devices',
        'Low power consumption',
        'Easy setup and configuration',
        'Wall-mountable'
      ],
      specifications: [
        { label: 'Protocols', value: 'Zigbee 3.0, Wi-Fi' },
        { label: 'Dimensions', value: '41mm diameter' },
        { label: 'Power', value: 'USB-C 5V' },
        { label: 'Connectivity', value: 'Wi-Fi 2.4GHz' }
      ]
    },
    'hub-m3': {
      id: 'hub-m3',
      name: 'Hub M3',
      image: hubM3,
      hero: hubM3Hero,
      featureImages: [hubM3Feature],
      description: 'Continuous Connectivity for Your Smart Devices',
      fullDescription: 'The Hub M3 ensures your smart home stays connected with enhanced reliability and performance. Built-in battery backup keeps your home running even during power outages.',
      features: [
        'Matter over Thread support',
        'Built-in battery backup',
        'Ethernet and Wi-Fi connectivity',
        'Enhanced security features',
        'Supports 200+ devices',
        'Advanced automation engine'
      ],
      specifications: [
        { label: 'Protocols', value: 'Matter, Thread, Zigbee 3.0' },
        { label: 'Battery Backup', value: 'Built-in rechargeable' },
        { label: 'Connectivity', value: 'Gigabit Ethernet, Wi-Fi 6' },
        { label: 'Storage', value: 'Local automation storage' }
      ]
    },
    'hub-m2': {
      id: 'hub-m2',
      name: 'Hub M2',
      image: hubM2,
      description: 'Central Hub with Built-in Speaker',
      fullDescription: 'More than just a hub, the M2 features a built-in speaker for voice notifications and doorbell chimes, making it the perfect all-in-one smart home controller.',
      features: [
        'Built-in speaker system',
        'IR remote control learning',
        'Zigbee 3.0 hub functionality',
        'Voice notification support',
        'Doorbell chime function',
        'Scene automation'
      ],
      specifications: [
        { label: 'Protocols', value: 'Zigbee 3.0, Wi-Fi, IR' },
        { label: 'Audio', value: '3W speaker' },
        { label: 'Power', value: 'DC 12V/1A' },
        { label: 'Connectivity', value: 'Wi-Fi 2.4GHz' }
      ]
    },
    'camera-hub-g3': {
      id: 'camera-hub-g3',
      name: 'Camera Hub G3',
      image: cameraG3,
      description: '2K Camera with Built-in Zigbee Hub',
      fullDescription: 'Dual-purpose device combining a 2K security camera with a Zigbee hub. Monitor your home while controlling all your smart devices from one central location.',
      features: [
        '2K QHD resolution',
        'Built-in Zigbee 3.0 hub',
        'AI person detection',
        '360° pan and tilt',
        'Night vision',
        'Two-way audio'
      ],
      specifications: [
        { label: 'Resolution', value: '2K QHD (2304 x 1296)' },
        { label: 'Protocols', value: 'Zigbee 3.0, Wi-Fi' },
        { label: 'Storage', value: 'MicroSD up to 512GB' },
        { label: 'Field of View', value: '110° diagonal' }
      ]
    },
    'camera-hub-g2h-pro': {
      id: 'camera-hub-g2h-pro',
      name: 'Camera Hub G2H Pro',
      image: cameraG2HPro,
      description: '1080p Camera with Zigbee Hub',
      fullDescription: 'Professional-grade camera with integrated Zigbee hub. HomeKit Secure Video support ensures your footage stays private and secure.',
      features: [
        '1080p Full HD video',
        'Zigbee 3.0 hub built-in',
        'HomeKit Secure Video',
        'AI-powered detection',
        'Local video storage',
        'Privacy shutter'
      ],
      specifications: [
        { label: 'Resolution', value: '1080p Full HD' },
        { label: 'Protocols', value: 'Zigbee 3.0, Wi-Fi' },
        { label: 'Compatibility', value: 'HomeKit, Alexa, Google' },
        { label: 'Storage', value: 'MicroSD + iCloud' }
      ]
    },
    'hub-e1': {
      id: 'hub-e1',
      name: 'Hub E1',
      image: hubE1,
      description: 'Compact USB-Powered Hub',
      fullDescription: 'The most portable Aqara hub, powered by USB for maximum flexibility. Perfect for renters and those who want a mobile smart home setup.',
      features: [
        'USB-powered portability',
        'Zigbee 3.0 support',
        'Plug-and-play setup',
        'Compact design',
        'Up to 32 device support',
        'Cloud automation'
      ],
      specifications: [
        { label: 'Protocols', value: 'Zigbee 3.0, Wi-Fi' },
        { label: 'Power', value: 'USB 5V' },
        { label: 'Dimensions', value: '46 x 46 x 14mm' },
        { label: 'Weight', value: '30g' }
      ]
    },
    'hub-m1s-gen-2': {
      id: 'hub-m1s-gen-2',
      name: 'Hub M1S Gen 2',
      image: hubM1SGen2,
      description: 'Advanced Zigbee Hub',
      fullDescription: 'Second generation of the popular M1S hub, featuring enhanced performance and expanded device support for larger smart homes.',
      features: [
        'Enhanced Zigbee range',
        'Supports 128+ devices',
        'RGB ambient lighting',
        'Built-in speaker',
        'Scene automation',
        'Multi-home support'
      ],
      specifications: [
        { label: 'Protocols', value: 'Zigbee 3.0, Wi-Fi' },
        { label: 'Range', value: 'Up to 30m indoor' },
        { label: 'Power', value: 'DC 5V/1A' },
        { label: 'Audio', value: 'Built-in speaker' }
      ]
    },
    'camera-hub-g2h': {
      id: 'camera-hub-g2h',
      name: 'Camera Hub G2H',
      image: cameraHubG2H,
      description: 'HomeKit Secure Video Hub',
      fullDescription: 'Original G2H camera hub with HomeKit Secure Video support. Your personal security camera and smart home hub in one elegant package.',
      features: [
        '1080p HD video',
        'HomeKit Secure Video',
        'Zigbee 3.0 hub',
        'Night vision',
        'Motion detection',
        'Two-way audio'
      ],
      specifications: [
        { label: 'Resolution', value: '1080p HD' },
        { label: 'Protocols', value: 'Zigbee 3.0, Wi-Fi' },
        { label: 'Field of View', value: '140° wide angle' },
        { label: 'Connectivity', value: 'Wi-Fi 2.4GHz' }
      ]
    },
    'aqara-hub': {
      id: 'aqara-hub',
      name: 'Aqara Hub',
      image: aqaraHub,
      description: 'Original Aqara Smart Home Hub',
      fullDescription: 'The original Aqara Hub that started it all. A reliable and affordable way to begin your smart home journey with Zigbee connectivity.',
      features: [
        'Zigbee 3.0 support',
        'RGB night light',
        'Built-in alarm',
        'Voice assistant compatible',
        'Easy setup',
        'Affordable entry point'
      ],
      specifications: [
        { label: 'Protocols', value: 'Zigbee 3.0, Wi-Fi' },
        { label: 'Power', value: 'AC plug-in' },
        { label: 'Device Support', value: 'Up to 32 devices' },
        { label: 'Features', value: 'RGB light, Alarm' }
      ]
    },
    'aqara-hub-m1': {
      id: 'aqara-hub-m1',
      name: 'Aqara Hub M1',
      image: aqaraHub2,
      description: 'Compact Zigbee 3.0 Hub',
      fullDescription: 'A compact and efficient Zigbee hub for smaller smart home setups. Perfect for apartments and single rooms.',
      features: [
        'Compact design',
        'Zigbee 3.0',
        'Low power consumption',
        'Multiple platform support',
        'Scene automation',
        'Wall plug design'
      ],
      specifications: [
        { label: 'Protocols', value: 'Zigbee 3.0, Wi-Fi' },
        { label: 'Power', value: 'AC plug-in' },
        { label: 'Device Support', value: 'Up to 32 devices' },
        { label: 'Dimensions', value: 'Compact wall plug' }
      ]
    },

    // Smart Door Lock Products
    'smart-lock-b50': {
      id: 'smart-lock-b50',
      name: 'Smart Lock B50',
      image: smartLockB50,
      hero: smartLockB50Hero,
      featureImages: [smartLockB50Feature1, smartLockB50Feature2],
      description: 'Remotely Controllable Lock Made Simple',
      fullDescription: 'With built-in Wi‑Fi 6 and no bridge required, you can lock, unlock, and view lock activity and status anytime and anywhere using the Aqara Home app, Alexa, or Google Home.',
      features: [
        'Remote control via app',
        'Password and keypad access',
        'Timed auto-lock',
        'Anti-peep password',
        'Offline passwords',
        'Emergency USB-C charging'
      ],
      detailedFeatures: [
        {
          title: 'No Hub Required',
          description: 'Built-in Wi‑Fi 6 connectivity allows for direct control without any additional hub or bridge. Lock, unlock, and monitor your door from anywhere using the Aqara Home app, Alexa, or Google Home (2.4GHz Wi-Fi only).'
        },
        {
          title: '6 Months Battery Life',
          description: '4 AA batteries last up to 6 months based on typical use (5 passcodes plus 5 remote unlocks per day). Batteries are easily replaceable. USB-C port allows emergency charging if power runs out.'
        },
        {
          title: 'Multiple Unlock Methods',
          description: 'Unlock your door with keypad passcode, app control, voice commands via Alexa or Google Assistant, physical key, or offline passwords that work without Wi-Fi or hub connection and can be issued remotely.'
        },
        {
          title: 'Anti-Peep Password Protection',
          description: 'Enhance security by adding random digits before or after your actual code to prevent others from seeing your PIN.'
        },
        {
          title: 'Backlit Keypad',
          description: 'Easily enter your access code even in the dark, thanks to the backlit keypad that illuminates for clear visibility in low-light conditions.'
        },
        {
          title: 'Works with Aqara Doorbells',
          description: 'Integrates with Aqara doorbells (including G410, G5), allowing you to see who is at the door and unlock it directly from the app.'
        },
        {
          title: 'Matter Support',
          description: 'By pairing with a compatible smart home hub (Aqara M3, G5, or M100), the Smart Lock B50 enables Matter connectivity, ensuring it works seamlessly with Apple Home, Home Assistant, SmartThings, and more.'
        },
        {
          title: 'Advanced Security Features',
          description: 'AES-128 encryption protects your data with bank-grade security. IPX3 weatherproof rating allows operation between -31°F ~ 150.8°F. Failed attempt lockout temporarily disables the system after multiple incorrect entries.'
        }
      ],
      accessMethods: [
        {
          name: 'Keypad Passcode',
          description: 'Create permanent, scheduled, or one-time passwords with anti-peep protection for enhanced security.'
        },
        {
          name: 'App Control',
          description: 'Lock and unlock remotely using the Aqara Home app from anywhere in the world.'
        },
        {
          name: 'Voice Control',
          description: 'Hands-free control through Amazon Alexa or Google Assistant voice commands.'
        },
        {
          name: 'Offline Passwords',
          description: 'Generate passwords that work without Wi-Fi or hub connection and can be shared remotely.'
        },
        {
          name: 'Physical Key',
          description: 'Traditional mechanical key access as a reliable backup method.'
        },
        {
          name: 'Rekey Support',
          description: 'Easily replace the lock cylinder with your existing one by removing just a screw, keeping your original keys.'
        }
      ],
      specifications: [
        { label: 'Access Methods', value: 'Keypad passcode, app control, voice commands (Alexa/Google Assistant), physical key, offline passwords' },
        { label: 'Wireless Protocols', value: 'Bluetooth 5.3, Wi-Fi 6 (2.4GHz)' },
        { label: 'Battery', value: '4 AA Batteries (6V)' },
        { label: 'Battery Life', value: 'Up to 6 months' },
        { label: 'Operating Temperature', value: 'Inner: -18°C ~ 55°C, Outer: -35°C ~ 66°C' },
        { label: 'Weatherproof Rating', value: 'IPX3' },
        { label: 'Security', value: 'AES-128 Encryption' }
      ]
    },
    'smart-lock-u200-lite': {
      id: 'smart-lock-u200-lite',
      name: 'Smart Lock U200 Lite',
      image: smartLockU200Lite,
      hero: smartLockU200LiteHero,
      featureImages: [smartLockU200LitePlatProduct],
      description: 'Smart Security for Classic Doors',
      fullDescription: 'The U200 Lite easily fits over your existing door lock, requiring no complex installation or modifications. With Matter over Thread support, it integrates seamlessly into your smart home ecosystem.',
      features: [
        'Retrofit design - no complex installation',
        'Matter over Thread support',
        'Auto-lock with built-in gyroscope',
        'NFC card unlocking',
        'Pull spring feature',
        '6-month rechargeable battery'
      ],
      detailedFeatures: [
        {
          title: 'Matter over Thread Support',
          description: 'Works with all major ecosystems including Apple Home, Aqara Home, Amazon Alexa, Google Home, Home Assistant, and SmartThings. With Matter over Thread, you get full functionality without compromise.'
        },
        {
          title: 'Auto-Lock on Close',
          description: 'Built-in gyroscope automatically locks the door on closing. This convenient feature ensures that your home is always protected without any additional sensors.'
        },
        {
          title: 'Flexible Unlock Methods',
          description: 'Includes NFC sticker card unlocking, Bluetooth unlocking, remote unlocking, and voice control (Siri or Alexa) providing users with flexible choices for every situation.'
        },
        {
          title: 'Rechargeable Li-ion Battery',
          description: 'Features a 2000 mAh rechargeable battery that lasts up to 6 months on a single charge. A low battery alert ensures you\'re never locked out unexpectedly.'
        },
        {
          title: 'Easy Installation & Broad Compatibility',
          description: 'The lock easily fits over the existing door lock, requiring no complex installation or modifications, as long as your current cylinder has an Emergency Function.'
        },
        {
          title: 'Pull Spring Feature',
          description: 'Automatically retracts the door latch upon unlocking, letting you open the door without touching the handle. Perfect for moments when your hands are full or when you prioritize hygiene.'
        },
        {
          title: 'Quiet Mode for Nighttime',
          description: 'Offers Quiet, Standard and Fast mode options, allowing you to experience quiet unlocking at night and fast unlocking during the day for a peaceful home environment.'
        },
        {
          title: 'Turn to Lock/Unlock',
          description: 'Turn the knob approximately 30°-60°, and the lock will automatically lock or unlock for convenient operation.'
        }
      ],
      accessMethods: [
        {
          name: 'App Bluetooth Unlocking',
          description: 'Conveniently unlock via your smartphone using Bluetooth connection.'
        },
        {
          name: 'App Remote Unlocking',
          description: 'Unlock the door remotely even if you are away from home using the internet connection.'
        },
        {
          name: 'Voice Control',
          description: 'Hands-free access with Siri or Alexa voice commands for seamless smart home integration.'
        },
        {
          name: 'NFC Sticker Card Unlocking',
          description: 'Bind the included NFC Sticker Card to Aqara Home to use tap-to-unlock functionality.'
        }
      ],
      specifications: [
        { label: 'Access Methods', value: 'App Bluetooth, remote unlocking, voice control (Siri/Alexa), NFC sticker card' },
        { label: 'Protocol', value: 'Matter over Thread' },
        { label: 'Battery', value: '2000 mAh Li-ion rechargeable' },
        { label: 'Battery Life', value: 'Up to 6 months per charge' },
        { label: 'Installation', value: 'Retrofit - no wiring required' },
        { label: 'Special Features', value: 'Auto-lock on close, pull spring feature, quiet mode, turn to lock' }
      ]
    },
    'smart-lock-u300': {
      id: 'smart-lock-u300',
      name: 'Smart Lock U300',
      image: smartLockU300,
      hero: smartLockU300Hero,
      description: 'A Smarter Handle on Home Security',
      fullDescription: 'Premium lever-style smart lock with advanced biometric authentication. Perfect for modern homes demanding both security and style.',
      contentSections: [
        {
          image: smartLockU300Feature,
          title: 'Multiple Unlock Methods',
          description: 'The Smart Lock U300 offers versatile access options including 3D fingerprint recognition, Apple Home Key, NFC cards, numeric passwords with anti-peep protection, app control, voice commands, and traditional mechanical key backup for maximum convenience and security.',
          note: ''
        }
      ],
      features: [
        '3D fingerprint sensor',
        'Apple Home Key support',
        'Multiple unlock methods',
        'Privacy mode',
        'Weather-resistant design',
        'Emergency power backup'
      ],
      detailedFeatures: [
        {
          title: 'Lever-Style Smart Lock Design',
          description: 'Premium lever-style handle lock with modern aesthetics that complements any home decor. Made from high-quality zinc alloy and aluminum materials for durability and elegant appearance.'
        },
        {
          title: 'Advanced 3D Fingerprint Sensor',
          description: 'Features a 3D fingerprint sensor with high accuracy and fast recognition speed. Stores up to 50 fingerprints with anti-spoofing technology to prevent unauthorized access.'
        },
        {
          title: 'Apple Home Key Support',
          description: 'Add your home key to Apple Wallet and unlock with a simple tap of your iPhone or Apple Watch. Works even when your device battery is low, providing ultimate convenience.'
        },
        {
          title: 'Multiple Unlock Methods',
          description: 'Supports fingerprint, Apple Home Key, NFC cards, numeric passwords with anti-peep protection, mechanical key, and app control for maximum flexibility.'
        },
        {
          title: 'Premium Build Quality',
          description: 'Frame constructed from zinc alloy and aluminum for superior durability and elegant aesthetics. Weather-resistant design suitable for outdoor installation.'
        },
        {
          title: 'Smart Automations',
          description: 'Integrates with major smart home platforms. Create scenes that trigger when specific users unlock the door, automate security systems, lighting, and climate control.'
        },
        {
          title: 'Long Battery Life',
          description: 'Energy-efficient design provides up to 18 months of battery life. Low battery warnings ensure you are never caught off guard.'
        },
        {
          title: 'Emergency Power Backup',
          description: 'USB-C emergency charging port ensures you can power the lock from outside if batteries die. Physical key access always available as ultimate backup.'
        }
      ],
      accessMethods: [
        {
          name: 'Fingerprint',
          description: '3D fingerprint sensor with fast recognition and high accuracy for secure biometric access.'
        },
        {
          name: 'Apple Home Key',
          description: 'Tap to unlock with iPhone or Apple Watch stored in Apple Wallet.'
        },
        {
          name: 'Password',
          description: 'Multiple password types including permanent, temporary, and scheduled access codes.'
        },
        {
          name: 'NFC Card',
          description: 'Quick tap-to-unlock using NFC-enabled cards or devices.'
        },
        {
          name: 'App Control',
          description: 'Remote control via Aqara Home app from anywhere with internet connection.'
        },
        {
          name: 'Voice Control',
          description: 'Hands-free access through Siri, Alexa, or Google Assistant.'
        },
        {
          name: 'Mechanical Key',
          description: 'Traditional physical key as ultimate backup access method.'
        }
      ],
      specifications: [
        { label: 'Access Methods', value: 'Fingerprint, Apple Home Key, NFC, password (permanent/periodic/one-time), app control, voice control, mechanical key, automation' },
        { label: 'Material', value: 'Premium zinc alloy with anodized aluminum' },
        { label: 'Battery Life', value: 'Up to 18 months' },
        { label: 'Protocols', value: 'Zigbee 3.0, Bluetooth' },
        { label: 'Fingerprint Capacity', value: '50 users' }
      ]
    },
    'smart-lock-u200': {
      id: 'smart-lock-u200',
      name: 'Smart Lock U200',
      image: smartLockU200,
      hero: smartLockU200Hero,
      featureImages: [smartLockU200Feature],
      description: 'Ultimate Smart Lock Retrofitted for You',
      fullDescription: 'The U200 offers the ultimate retrofit smart lock experience with Matter support, bringing the latest smart home standards to your existing door.',
      features: [
        'Matter protocol certified',
        'Apple Home Key support',
        'Auto-unlock with geofencing',
        'One-time guest codes',
        'Activity history',
        'Voice assistant compatible'
      ],
      detailedFeatures: [
        {
          title: 'Matter Protocol Certified',
          description: 'Fully certified Matter device that works seamlessly with Apple Home, Google Home, Amazon Alexa, SmartThings, and other Matter-compatible platforms. Enjoy true interoperability and future-proof your smart home.'
        },
        {
          title: 'Apple Home Key Integration',
          description: 'Add your home key to Apple Wallet for easy tap-to-unlock with iPhone or Apple Watch. Share digital keys with family and guests. Works even when your device battery is low.'
        },
        {
          title: 'Retrofit Installation',
          description: 'Tool-free installation that fits over your existing lock. No need to replace your entire lock system or modify your door. Works with standard deadbolt locks.'
        },
        {
          title: 'Comprehensive Password Management',
          description: 'Create permanent passwords for family, temporary one-time passwords for guests, and scheduled passwords for service providers. Anti-peep password feature protects your PIN from prying eyes.'
        },
        {
          title: 'Smart Home Integration',
          description: 'Works with Apple HomeKit, Google Assistant, and Alexa for voice control and automation. Integrate with your existing smart home ecosystem seamlessly.'
        },
        {
          title: 'DPS Double Protection System',
          description: 'Dual Protection System provides enhanced security with two-layer authentication options. Tamper alarm triggers when unauthorized access is attempted.'
        },
        {
          title: 'Weather-Resistant Design',
          description: 'Built to withstand outdoor elements with weather-resistant construction. Operates reliably in various temperature and humidity conditions.'
        },
        {
          title: 'Long Battery Life',
          description: 'Energy-efficient design provides up to 12 months of battery life with regular use. Low battery warnings and emergency power port ensure uninterrupted access.'
        },
        {
          title: 'C-Level Lock Cylinder',
          description: 'High-security C-level lock cylinder provides superior protection against picking and drilling. Mechanical key access always available as ultimate backup.'
        }
      ],
      accessMethods: [
        {
          name: 'Fingerprint',
          description: 'High-precision biometric access with capacity for 50 fingerprints and fast recognition.'
        },
        {
          name: 'Password',
          description: 'Permanent, temporary, and scheduled passwords with anti-peep protection.'
        },
        {
          name: 'NFC',
          description: 'Quick tap-to-unlock using NFC cards or compatible devices.'
        },
        {
          name: 'App Control',
          description: 'Remote unlock and management via Aqara Home mobile application.'
        },
        {
          name: 'Voice Control',
          description: 'Hands-free access through Siri, Alexa, or Google Assistant.'
        },
        {
          name: 'HomeKit',
          description: 'Native Apple HomeKit support for seamless integration with Apple ecosystem.'
        },
        {
          name: 'Mechanical Key',
          description: 'Traditional physical key with C-level cylinder as reliable backup.'
        }
      ],
      specifications: [
        { label: 'Access Methods', value: 'Fingerprint (50 capacity), password (permanent/temporary/scheduled), NFC, app control, voice (Siri/Alexa/Google), HomeKit, mechanical key' },
        { label: 'Protocols', value: 'Zigbee 3.0, Bluetooth' },
        { label: 'Battery Life', value: 'Up to 12 months' },
        { label: 'Security', value: 'C-level lock cylinder, DPS double protection' },
        { label: 'Special Features', value: 'Anti-peep password, tamper alarm, weather-resistant' }
      ]
    },
    'smart-lock-u50': {
      id: 'smart-lock-u50',
      name: 'Smart Lock U50',
      image: smartLockU50,
      heroVideo: smartLockU50HeroVideo,
      featureImages: [smartLockU50Feature],
      description: 'Cutting-Edge 3D Facial Recognition Lock',
      fullDescription: 'The Smart Lock U50 features advanced 3D facial recognition technology combined with fingerprint authentication for secure, hands-free entry. Perfect for families seeking the ultimate in biometric security.',
      features: [
        '3D facial recognition',
        'Fingerprint sensor - 50 prints',
        'Low-light performance',
        'Anti-spoofing protection',
        'Voice assistant support',
        'Long battery life'
      ],
      detailedFeatures: [
        {
          title: '3D Facial Recognition Technology',
          description: 'Advanced 3D structured light facial recognition provides secure, hands-free entry. AI-powered detection accurately identifies authorized users in less than 1 second, even in varying lighting conditions.'
        },
        {
          title: 'Low-Light Performance',
          description: 'Infrared sensors and AI algorithms work together to recognize faces accurately in low-light or nighttime conditions. No need to worry about unlocking in the dark.'
        },
        {
          title: 'Anti-Spoofing Protection',
          description: '3D liveness detection prevents unauthorized access using photos or videos. Advanced security algorithms ensure only real, authorized users can unlock the door.'
        },
        {
          title: 'Multiple Biometric Options',
          description: 'Combines 3D facial recognition with fingerprint sensor for dual biometric authentication. Store up to 50 faces and 50 fingerprints for comprehensive family access.'
        },
        {
          title: 'Smart Password Management',
          description: 'Create permanent, temporary, and scheduled passwords with anti-peeping protection. Add random digits before or after your actual code for enhanced privacy.'
        },
        {
          title: 'Comprehensive Smart Home Integration',
          description: 'Works with major smart home platforms including Apple HomeKit, Google Assistant, and Alexa. Create automations based on who unlocks the door.'
        },
        {
          title: 'Fast Recognition Speed',
          description: 'Face recognition completes in less than 1 second for quick, seamless entry. No need to stop or pose - just approach and enter.'
        },
        {
          title: 'Long Battery Life & Emergency Access',
          description: 'Up to 12 months battery life with low battery warnings. Emergency USB-C charging port and physical key ensure you are never locked out.'
        }
      ],
      accessMethods: [
        {
          name: '3D Face Recognition',
          description: 'Advanced 3D facial recognition with AI-powered detection for hands-free, secure entry in < 1 second.'
        },
        {
          name: 'Fingerprint',
          description: 'High-precision fingerprint sensor with capacity for 50 fingerprints as backup biometric option.'
        },
        {
          name: 'Password',
          description: 'Multiple password types with anti-peeping protection - add random digits for privacy.'
        },
        {
          name: 'NFC Card',
          description: 'Quick tap-to-unlock using NFC-enabled cards or compatible devices.'
        },
        {
          name: 'App Control',
          description: 'Remote unlock and management via smart home mobile applications.'
        },
        {
          name: 'Voice Control',
          description: 'Hands-free control through Siri, Alexa, or Google Assistant voice commands.'
        },
        {
          name: 'Mechanical Key',
          description: 'Traditional physical key access as ultimate backup method.'
        }
      ],
      specifications: [
        { label: 'Access Methods', value: '3D face recognition (50 faces), fingerprint (50 prints), password (permanent/temporary/scheduled), NFC card, app control, voice control, mechanical key' },
        { label: 'Face Recognition Speed', value: '< 1 second' },
        { label: 'Face Capacity', value: '50 faces' },
        { label: 'Fingerprint Capacity', value: '50 fingerprints' },
        { label: 'Battery Life', value: 'Up to 12 months' },
        { label: 'Special Features', value: 'Anti-spoofing 3D detection, low-light recognition, anti-peep password' },
        { label: 'Emergency Access', value: 'USB-C charging port, mechanical key' }
      ]
    },
    'smart-lock-u100': {
      id: 'smart-lock-u100',
      name: 'Smart Lock U100',
      image: smartLockU100,
      hero: smartLockU100Hero,
      featureImages: [smartLockU100Feature],
      description: 'Your Key to a Smarter, Safer Home',
      fullDescription: 'The Smart Lock U100 combines cutting-edge biometric security with seamless smart home integration. Fully supports Apple Home app and can be unlocked by tapping with iPhone or Apple Watch even when the device is out of power.',
      features: [
        'Apple Home & Home Key support',
        'Fingerprint reader - 50 prints',
        'Matter compatible via hub',
        'Auto-lock with gyroscope',
        'IP65 rated outer panel',
        '8-month battery life'
      ],
      detailedFeatures: [
        {
          title: 'Apple Home and Home Key Support',
          description: 'Fully supports the Apple Home app and can be unlocked by tapping it with an iPhone or Apple Watch even when the Apple device is out of power. Seamlessly integrated into your Apple ecosystem.'
        },
        {
          title: 'Built-in Fingerprint Reader',
          description: 'High-precision fingerprint reader offers 98.6% accuracy rate and stores up to 50 fingerprints locally. Recognition time is less than 0.5 seconds for effortless entry.'
        },
        {
          title: 'Matte Keypad with Anti-Peep Password',
          description: 'Equipped with a matte keypad that allows access with Anti-peep Password, enabling you to add random digits to your passcode. Choose from permanent, periodic and one-time passwords for different access needs.'
        },
        {
          title: 'Matter & Ecosystem Compatibility',
          description: 'Built on Zigbee protocol, compatible with Matter and other ecosystems like Google Home, Alexa, IFTTT. Easily integrated into wide range of smart home setups with automations that start the moment you unlock the door.'
        },
        {
          title: 'BHMA Level 3 Security Standard',
          description: 'Complies with the same safety standard as BHMA Level 3 for structural security. Data safeguarded by end-to-end encryption using secure 128-bit AES algorithm. Fingerprints stored locally only.'
        },
        {
          title: 'Built-in Gyroscope for Auto-Lock',
          description: 'Features built-in gyroscope for lock status detection without additional sensors. Enables Auto Locking and Door not Locked functionality. Includes Do Not Disturb and Passage Modes for family and office use.'
        },
        {
          title: 'IP65 Rated & Long Battery Life',
          description: 'Outer panel is IP65 rated with operating temperature range -31°F~150°F. Energy-efficient Zigbee protocol provides up to 8 months battery life with AA batteries that are easily replaced.'
        },
        {
          title: 'Emergency Backup Options',
          description: 'Physical keys and USB-C emergency port at outer panel ensure you always have backup access. Low battery alarm provides advance warning before power runs out.'
        }
      ],
      accessMethods: [
        {
          name: 'Apple Home Key',
          description: 'Tap to unlock with iPhone or Apple Watch via Apple Home, works even when devices are powered off.'
        },
        {
          name: 'Fingerprint',
          description: 'High-precision biometric access with 98.6% accuracy, <0.5s recognition time, stores up to 50 fingerprints.'
        },
        {
          name: 'Permanent Password',
          description: 'Set permanent passwords for family members with anti-peep protection for enhanced privacy.'
        },
        {
          name: 'Periodic Password',
          description: 'Time-limited passwords that work only during specified periods for scheduled access.'
        },
        {
          name: 'One-Time Password',
          description: 'Locally generated passwords for guests that work only once, even without internet connection.'
        },
        {
          name: 'App Control',
          description: 'Remote lock and unlock via Aqara Home app, Apple Home, Google Home, or Alexa apps.'
        },
        {
          name: 'Voice Control',
          description: 'Hands-free access via Siri, Alexa, or Google Assistant voice commands.'
        },
        {
          name: 'NFC Tags',
          description: 'Convenient contactless access using included NFC tags, ideal for children or elderly.'
        },
        {
          name: 'Mechanical Key',
          description: 'Traditional physical key access as ultimate backup method.'
        },
        {
          name: 'Automation',
          description: 'Trigger smart home scenes based on who unlocked the door and create personalized automations.'
        }
      ],
      specifications: [
        { label: 'Access Methods', value: 'Apple Home Key, fingerprint (98.6% accuracy, <0.5s), permanent/periodic/one-time passwords, app control, voice (Siri/Alexa/Google), NFC tags, mechanical key, automation' },
        { label: 'Protocols', value: 'Zigbee 3.0, Bluetooth, Matter (via Aqara hub)' },
        { label: 'Battery', value: '4x AA batteries' },
        { label: 'Battery Life', value: 'Up to 8 months (8 unlocks/day)' },
        { label: 'Fingerprint Capacity', value: '50 users' },
        { label: 'Recognition Time', value: '<0.5 seconds' },
        { label: 'Recognition Accuracy', value: '98.6%' },
        { label: 'Operating Temperature', value: '-31°F ~ 150°F (-35°C ~ 65°C)' },
        { label: 'Weatherproof Rating', value: 'IP65 (Outer Panel)' },
        { label: 'Security Standard', value: 'BHMA Level 3, AES-128 Encryption' },
        { label: 'Installation', value: 'DIY - replaces single cylinder deadbolt' }
      ]
    },
    'smart-lock-d200i': {
      id: 'smart-lock-d200i',
      name: 'Smart Lock D200i',
      image: smartLockD200i,
      hero: smartLockD200iHero,
      featureImages: [smartLockD200iFeature],
      description: 'Advanced Facial Recognition Lock',
      fullDescription: 'The D200i features cutting-edge 3D facial recognition technology for seamless hands-free entry. Advanced AI ensures accurate recognition in various lighting conditions.',
      features: [
        '3D facial recognition',
        'AI-powered detection',
        'Works in low light',
        'Multiple access methods',
        'Anti-peeping password',
        'Smart home integration'
      ],
      specifications: [
        { label: 'Access Methods', value: 'Face ID, Fingerprint, Password, NFC, App, Key' },
        { label: 'Face Capacity', value: '50 faces' },
        { label: 'Battery Life', value: 'Up to 12 months' },
        { label: 'Recognition Speed', value: '< 1 second' }
      ]
    },
    'smart-lock-u400': {
      id: 'smart-lock-u400',
      name: 'Smart Lock U400',
      image: smartLockU400,
      heroVideo: smartLockU400HeroVideo,
      featureVideo: smartLockU400FeatureVideo,
      description: 'Unlocks on Approach. No Contact, No Biometrics.',
      fullDescription: 'Powered by Ultra-Wideband (UWB), the Smart Lock U400 unlocks as you approach with your iPhone or Apple Watch — a hands-free, privacy-preserving entry experience with no codes and no biometric checks. As an Aliro enabled lock, UWB unlocking will extend to more devices across different ecosystems.',
      features: [
        'UWB hands-free unlocking',
        'Apple Home Key support',
        'Fingerprint in 0.3 seconds',
        'Matter over Thread',
        'Rechargeable battery',
        'BHMA certified'
      ],
      detailedFeatures: [
        {
          title: 'Hands-Free UWB Unlocking',
          description: 'The Smart Lock U400 unlocks as you approach with your iPhone or Apple Watch using Ultra-Wideband technology. No need to take out your phone or touch anything - perfect when your hands are full, raining heavily, or wearing gloves.'
        },
        {
          title: 'Precise Position Detection',
          description: 'Based on range and angle measurements, UWB detects your exact position and understands your unlock intention. It unlocks precisely when you\'re ready to enter and avoids any accidental or delayed openings.'
        },
        {
          title: 'Apple Home Key in Wallet',
          description: 'Simply add the Apple home key to your Wallet and unlock your door with your iPhone or Apple Watch—even when the devices are powered off. Easily share the home key with family members or provide guest codes to visitors.'
        },
        {
          title: 'Fingerprint Unlocking in 0.3 Seconds',
          description: 'Built-in ergonomic fingerprint reader can securely store up to 50 fingerprints for quick touch-to-open access with a highly accurate recognition rate of up to 98.6%.'
        },
        {
          title: 'Matter over Thread Support',
          description: 'Works by design with Apple Home, Home Assistant, Google Home, Amazon Alexa, Samsung SmartThings and other ecosystems, ensuring stable and reliable performance. Samsung Wallet support coming in Q1 2026.'
        },
        {
          title: 'Rechargeable Battery - 6 Months',
          description: 'Equipped with rechargeable batteries that only require a few hours to fully charge and last up to 6 months. Built-in USB-C port allows indoor charging with a power bank. Emergency charging port available for outdoor power supply.'
        },
        {
          title: 'BHMA Certified & IP65 Weatherproof',
          description: 'Proven to meet industry standard for reliable residential security. Engineered to withstand dust, splashes, and heavy rain, delivering reliable performance even in demanding outdoor environments.'
        },
        {
          title: 'Advanced Smart Features',
          description: 'Auto-lock on close with built-in gyro sensor, night latch mode for secure sleep, do not disturb mode for quiet hours, and rekeyable design for changing physical keys without replacing the cylinder.'
        }
      ],
      accessMethods: [
        {
          name: 'UWB Hands-Free Unlock',
          description: 'Approach-based unlocking with iPhone or Apple Watch using Ultra-Wideband technology - no contact needed.'
        },
        {
          name: 'Apple Home Key',
          description: 'Tap to unlock with iPhone or Apple Watch via Wallet, works even when devices are powered off.'
        },
        {
          name: 'Fingerprint',
          description: 'Fast 0.3-second fingerprint recognition with capacity for up to 50 fingerprints and 98.6% accuracy.'
        },
        {
          name: 'Permanent Password',
          description: 'Set permanent passwords for family members with anti-peep protection.'
        },
        {
          name: 'Offline Password',
          description: 'Generate temporary passwords that work without internet connection.'
        },
        {
          name: 'Scheduled Password',
          description: 'Create time-limited passwords with custom validity periods.'
        },
        {
          name: 'App Control',
          description: 'Remote lock and unlock control through Matter-compatible smart home apps.'
        },
        {
          name: 'Voice Control',
          description: 'Hands-free control via Siri, Alexa, or Google Assistant voice commands.'
        },
        {
          name: 'Mechanical Key',
          description: 'Traditional physical key access with rekeyable cylinder design.'
        },
        {
          name: 'NFC Card',
          description: 'Unlock using NFC cards or tags for convenient contactless access.'
        },
        {
          name: 'Automation',
          description: 'Create smart home scenes that trigger when the lock is operated.'
        }
      ],
      specifications: [
        { label: 'Access Methods', value: 'UWB hands-free, Apple Home Key, fingerprint (0.3s), permanent/offline/scheduled passwords, app control, voice control, mechanical key, NFC card, automation' },
        { label: 'Protocols', value: 'Matter over Thread, UWB (Ultra-Wideband), Bluetooth' },
        { label: 'Battery', value: 'Rechargeable Li-ion' },
        { label: 'Battery Life', value: 'Up to 6 months per charge' },
        { label: 'Charging', value: 'USB-C indoor & emergency outdoor port' },
        { label: 'Fingerprint Capacity', value: '50 users' },
        { label: 'Recognition Accuracy', value: '98.6%' },
        { label: 'Operating Temperature', value: '-18°C ~ 55°C (-0.4°F ~ 131°F)' },
        { label: 'Weatherproof Rating', value: 'IP65 (Outer Panel)' },
        { label: 'Certification', value: 'BHMA Certified, Rekeyable Design' }
      ]
    },
    'smart-lock-a100': {
      id: 'smart-lock-a100',
      name: 'Smart Door Lock A100',
      image: smartLockA100,
      hero: smartLockA100Hero,
      featureImages: [smartLockA100Feature],
      description: 'Zigbee Connected Smart Lock',
      fullDescription: 'The A100 provides reliable Zigbee-connected smart lock functionality with essential features for home security.',
      features: [
        'Zigbee connectivity',
        'Fingerprint access',
        'Numeric password',
        'Auto-lock feature',
        'Low battery warning',
        'Emergency key access'
      ],
      detailedFeatures: [
        {
          title: '18-Month Battery Life',
          description: 'Thanks to Aqara\'s battery saving technologies, the included 8 AA-size batteries can last for more than 1.5 years*.'
        },
        {
          title: 'Zigbee 3.0 and Bluetooth Support',
          description: 'Zigbee, the most stable and reliable smart home technology, is used to support automations and cloud integrations, while Bluetooth allows to connect directly to the phone.'
        },
        {
          title: '9 Unlock Methods',
          description: 'Permanent, one-time and configurable passwords, fingerprint, NFC card, mechanical key, Aqara Home app, HomeKit / Siri, Google Assistant. Multiple unlock methods to easily deal with different situations.'
        },
        {
          title: 'Fast and Ergonomic Fingerprint Reader',
          description: 'A fingerprint reader is embedded into the handle so that it will naturally touch it when opening the door. As a result, the verification will be faster and easier than ever.'
        },
        {
          title: 'Google Assistant and HomeKit Support',
          description: 'The Door Lock A100 is designed to work natively with HomeKit and will also support the unlock via Google Assistant.'
        },
        {
          title: 'Remotely-Configurable Passwords and Settings',
          description: 'Finally, the passwords and lock settings can be configured remotely via Zigbee, which allows the A100 to be used in property rental or hotel industry.'
        },
        {
          title: 'Mechanical Key and Type-C Port',
          description: 'Even if the batteries run out, you can still open the A100 by using a mechanical key or by charging it via the hidden Type-C port.'
        },
        {
          title: 'Keypad with Away Mode Button',
          description: 'Apart from a keypad that is invisible until you touch it, the A100 has a separate Away Mode button that can be used in automations.'
        }
      ],
      accessMethods: [
        {
          name: 'Permanent Passwords',
          description: 'Set permanent passwords for family members and regular users that never expire.'
        },
        {
          name: 'One-Time Passwords',
          description: 'Generate temporary passwords for guests that automatically expire after single use.'
        },
        {
          name: 'Configurable Passwords',
          description: 'Create time-limited passwords with custom validity periods for flexible access control.'
        },
        {
          name: 'Fingerprint',
          description: 'Fast and secure fingerprint recognition with capacity for up to 50 fingerprints.'
        },
        {
          name: 'NFC Card',
          description: 'Unlock using NFC cards or tags for convenient contactless access.'
        },
        {
          name: 'Mechanical Key',
          description: 'Traditional key access as a reliable backup method in any situation.'
        },
        {
          name: 'Aqara Home App',
          description: 'Remote unlock and lock control through the Aqara Home mobile application.'
        },
        {
          name: 'HomeKit / Siri',
          description: 'Voice control and automation through Apple HomeKit and Siri voice commands.'
        },
        {
          name: 'Google Assistant',
          description: 'Hands-free control using Google Assistant voice commands for smart home integration.'
        }
      ],
      specifications: [
        { 
          label: 'Access Methods', 
          value: 'Permanent, one-time and configurable passwords, fingerprint, NFC card, mechanical key, Aqara Home app, HomeKit / Siri, Google Assistant. Multiple unlock methods to easily deal with different situations.' 
        },
        { label: 'Protocol', value: 'Zigbee 3.0' },
        { label: 'Battery Life', value: 'Up to 18 months (8 AA batteries)' },
        { label: 'Fingerprint Capacity', value: '50 users' },
        { label: 'Password Capacity', value: 'Up to 100 passwords' },
        { label: 'NFC Card Capacity', value: 'Up to 100 cards' }
      ]
    },
    'smart-lock-d100': {
      id: 'smart-lock-d100',
      name: 'Smart Door Lock D100',
      image: smartLockD100,
      hero: smartLockD100Hero,
      featureImages: [smartLockD100Feature],
      description: 'The Fully Automatic Lock Redefined',
      fullDescription: 'The D100 features a fully automatic lock body for superfast and effortless opening without pushing the handle. With 9 unlock methods and wide ecosystem compatibility, including Apple Home Key and Google Assistant support.',
      features: [
        'Fully-automatic lock body',
        'Apple Home Key support',
        '9 unlock methods',
        'Rechargeable Li-ion battery',
        '3D fingerprint reader',
        'Real-time status monitoring'
      ],
      detailedFeatures: [
        {
          title: 'Fully-Automatic Lock Body',
          description: 'Unlike traditional handle locks, the D100 has a fully automatic lock body. Easily open the door without pushing the handle or turning a knob - the whole process is done in one smooth motion. Can be installed onto stylish pull handle doors.'
        },
        {
          title: 'Fingerprint Recognizing While Pushing',
          description: '3D semiconductor fingerprint reader with sapphire coating for better durability. Precise Biometrics technology effectively rejects false fingerprints for extreme safety. Recognition happens as you push the door.'
        },
        {
          title: '9 Unlock Methods for Every Situation',
          description: 'Permanent passwords, one-time passwords, remotely-configurable passwords, fingerprint, NFC card (included), mechanical key, Aqara Home App (Bluetooth, Remote, Automations), HomeKit/Siri (including Apple Home Key), and Google Assistant (Cloud via Hub).'
        },
        {
          title: 'Rechargeable Li-Ion Battery',
          description: 'Up to 12-month battery life with detachable battery that can be charged using the USB-C port. Alternatively, the lock can be charged from outside via another USB-C port for emergency situations.'
        },
        {
          title: 'Multiple Ecosystem Support',
          description: 'Designed to work with HomeKit including the newest Apple Home Key feature, and also supports unlocking via Google Assistant or Google Home app. Fully integrated into your smart home.'
        },
        {
          title: 'Premium Design & Security',
          description: 'Metal unibody made of glass and metal with premium build quality. Nano coating makes it resistant to high temperatures. Upgraded body equipped with three bolts coupled with highly secured lock cylinder.'
        },
        {
          title: 'Comprehensive Security Features',
          description: 'Security chip located in inner panel. Mechanical emergency unlock knob works even with battery removed. Local and remote tamper alerts. Auto-lock right after door is closed. End-to-end encryption for unlock data.'
        },
        {
          title: 'Smart Automations',
          description: 'Trigger different scenes depending on who has entered. Child Safety Mode prevents small children from opening door accidentally. Real-time status monitoring with notifications to your phone.'
        }
      ],
      accessMethods: [
        {
          name: 'Fingerprint',
          description: '3D semiconductor fingerprint reader with sapphire coating, recognizes while pushing for seamless entry.'
        },
        {
          name: 'Permanent Passwords',
          description: 'Set permanent passwords for family members and regular users that never expire.'
        },
        {
          name: 'One-Time Passwords',
          description: 'Generate temporary passwords for guests that expire after single use.'
        },
        {
          name: 'Remotely-Configurable Passwords',
          description: 'Configure passwords remotely via Zigbee for rental properties or hotel industry use.'
        },
        {
          name: 'NFC Card',
          description: 'Unlock using included NFC cards for convenient contactless access.'
        },
        {
          name: 'Mechanical Key',
          description: 'Traditional physical key access with highly secured C-grade lock cylinder.'
        },
        {
          name: 'Aqara Home App',
          description: 'Control via Bluetooth locally, remote unlock, and create smart home automations.'
        },
        {
          name: 'HomeKit / Siri',
          description: 'Full HomeKit support including Apple Home Key, Bluetooth, remote access, and Siri voice commands.'
        },
        {
          name: 'Google Assistant',
          description: 'Voice control and remote access via Google Home app (requires Aqara hub).'
        }
      ],
      specifications: [
        { label: 'Access Methods', value: 'Fingerprint (3D sapphire), permanent/one-time/remotely-configurable passwords, NFC card (included), mechanical key, Aqara Home app, HomeKit/Siri (Apple Home Key), Google Assistant' },
        { label: 'Lock Type', value: 'Fully-Automatic Mortise Lock' },
        { label: 'Protocols', value: 'Zigbee 3.0, Bluetooth' },
        { label: 'Battery', value: 'Li-ion 2480mAh with USB-C charging' },
        { label: 'Battery Life', value: 'Up to 12 months' },
        { label: 'Fingerprint Reader', value: '3D semiconductor with sapphire coating, 160 x 160 resolution' },
        { label: 'Speaker', value: 'Dual (103 dB)' },
        { label: 'Operating Temperature', value: '-10°C ~ 55°C' },
        { label: 'Door Thickness Support', value: '40-120 mm (supports handle bar doors)' },
        { label: 'Special Features', value: 'Child lock switch, away mode & doorbell buttons, emergency unlock knob' }
      ]
    },
    'smart-lock-n100': {
      id: 'smart-lock-n100',
      name: 'Smart Door Lock N100',
      image: smartLockN100,
      hero: smartLockN100Hero,
      featureImages: [smartLockN100Feature],
      description: 'NFC Enabled Smart Lock with Zigbee 3.0',
      fullDescription: 'The updated international version of our most popular smart door lock. Now with Zigbee 3.0 support for faster, more stable, and energy-efficient smart home connectivity. Features ergonomic fingerprint reader and works with Apple HomeKit.',
      features: [
        'Zigbee 3.0 support',
        'Apple HomeKit compatible',
        'Ergonomic fingerprint reader',
        'Integrated doorbell function',
        '18-month battery life',
        'High-quality aluminum design'
      ],
      detailedFeatures: [
        {
          title: 'Zigbee 3.0 & HomeKit Support',
          description: 'The N100 Zigbee Edition supports Zigbee 3.0, the fastest, most stable, and energy-efficient smart home technology, as well as Bluetooth. Has a built-in Apple security chip and supports the best smart home ecosystem for Apple devices.'
        },
        {
          title: 'Precise 3D Fingerprint Reader',
          description: 'Ergonomic fingerprint reader is embedded right in the handle. Just open the door by pressing the handle, and the sensor reads your fingerprint. Identification speed: ≤300ms, identification rate: up to 98.7%. Fingerprint algorithm by Precise Biometrics.'
        },
        {
          title: '6 Unlock Methods',
          description: 'Fingerprint unlock, numeric keypad with anti-peep password, NFC (Mi Band NFC, NFC smartphones, Aqara NFC cards), mechanical key with C-grade cylinder, HomeKit app, and Aqara Home/Zigbee remote unlock.'
        },
        {
          title: 'Extra Long Battery Life',
          description: 'Typically, the 8 AA-type batteries will last for more than 1.5 years. Battery is separated into two sections - if one section discharges, the other one will still work. Emergency charging via hidden Type-C port.'
        },
        {
          title: 'Integrated Smart Doorbell',
          description: 'Built-in doorbell button with powerful speaker notifies you when visitors arrive. Doorbell ringtone can also be played by any Aqara Hub with built-in speaker. Notifications sent to phone even when far away, with full history logging.'
        },
        {
          title: 'Maximum Security Features',
          description: 'Damage sensor for immediate tampering notifications. Auto-lock immediately after door closes. Anti-peephole break-in design. Master lock knob requires admin fingerprint/password. Electromagnetic protection against Tesla coil attacks. Three independent bolt sensors.'
        },
        {
          title: 'High-Quality Design',
          description: 'Frame and handle made of anodized aluminum for superior feeling and extra durability. Hidden 10-digit keypad with anti-peep password protection allows adding random symbols along with 6-digit password for privacy.'
        },
        {
          title: 'Smart Automations',
          description: 'Records who opened the lock and by what method. Configure automations based on who arrived home. Trigger different scenes for different family members. Arm/disarm security system automatically by lifting handle.'
        }
      ],
      accessMethods: [
        {
          name: 'Fingerprint Unlock',
          description: '3D fingerprint reader on handle with ≤300ms speed and 98.7% accuracy, developed by Precise Biometrics.'
        },
        {
          name: 'Numeric Keypad',
          description: 'Hidden 10-digit keypad with anti-peep password - add random digits before/after actual code.'
        },
        {
          name: 'One-Time Password',
          description: 'Aqara Home app generates one-time passwords that can be shared, works even without internet.'
        },
        {
          name: 'NFC',
          description: 'Unlock with Xiaomi Mi Band NFC, NFC-enabled smartphones, or Aqara NFC cards.'
        },
        {
          name: 'Mechanical Key',
          description: 'Traditional lock functionality with mechanical keys and highly secure C-grade cylinder.'
        },
        {
          name: 'HomeKit Unlock',
          description: 'Apple device users can unlock via Apple Home app using HomeKit secured protocol.'
        },
        {
          name: 'Aqara Home App',
          description: 'Unlock by Bluetooth of mobile phone locally or remotely via Zigbee hub connection.'
        }
      ],
      specifications: [
        { label: 'Access Methods', value: 'Fingerprint (98.7% accuracy, ≤300ms), numeric keypad with anti-peep, one-time passwords, NFC (Mi Band/smartphone/cards), mechanical key, HomeKit, Aqara Home app' },
        { label: 'Protocols', value: 'Zigbee 3.0, Bluetooth' },
        { label: 'Supported Platforms', value: 'Aqara Home, Apple HomeKit' },
        { label: 'Battery', value: '8x AA batteries (dual section)' },
        { label: 'Battery Life', value: 'More than 1.5 years (18 months)' },
        { label: 'Emergency Charging', value: 'Hidden Type-C port' },
        { label: 'Material', value: 'Anodized Aluminum frame and handle' },
        { label: 'Security Features', value: 'C-grade cylinder, damage sensor, auto-lock, anti-peephole design, electromagnetic protection' },
        { label: 'Special Features', value: 'Integrated doorbell, master lock knob, three bolt sensors, configurable automations' }
      ]
    },

    // Smart Home Sensor Products
    'presence-multi-sensor-fp300': {
      id: 'presence-multi-sensor-fp300',
      name: 'Presence Multi-Sensor FP300',
      image: presenceFP300,
      description: 'Wireless Sensor with 5-in-1 Detection Capability',
      fullDescription: 'The FP300 is the ultimate multi-sensor combining presence detection, motion, temperature, humidity, and light sensing in one compact device.',
      features: [
        'mmWave presence detection',
        'Temperature and humidity monitoring',
        'Ambient light sensor',
        'Motion detection',
        'Zone-based detection',
        'Matter protocol support'
      ],
      specifications: [
        { label: 'Detection Range', value: 'Up to 6m' },
        { label: 'Protocols', value: 'Matter, Thread' },
        { label: 'Battery Life', value: 'Up to 1 year' },
        { label: 'Mounting', value: 'Magnetic or adhesive' }
      ]
    },
    'vibration-sensor-t1': {
      id: 'vibration-sensor-t1',
      name: 'Vibration Sensor T1',
      image: vibrationT1,
      description: 'Detects Abnormal Movements, Tilts, and Drops',
      fullDescription: 'Advanced 6-axis sensor that detects vibrations, tilting, and drops. Perfect for security monitoring and automation triggers.',
      features: [
        '6-axis detection',
        'Vibration sensitivity adjustment',
        'Tilt angle detection',
        'Drop detection',
        'Compact size',
        'Long battery life'
      ],
      specifications: [
        { label: 'Protocols', value: 'Zigbee 3.0' },
        { label: 'Battery', value: 'CR2032' },
        { label: 'Battery Life', value: 'Up to 2 years' },
        { label: 'Detection Modes', value: 'Vibration, Tilt, Drop' }
      ]
    },
    'climate-sensor-w100': {
      id: 'climate-sensor-w100',
      name: 'Climate Sensor W100',
      image: climateW100,
      description: 'Precise Sensor with LCD Display',
      fullDescription: 'Monitor your indoor climate with Swiss-precision sensors. Built-in LCD display shows real-time temperature and humidity readings.',
      features: [
        'Swiss Sensirion sensor',
        'LCD display',
        'Temperature and humidity monitoring',
        'Historical data tracking',
        'Smart home automation',
        'Compact design'
      ],
      specifications: [
        { label: 'Temperature Range', value: '-20°C to 60°C' },
        { label: 'Humidity Range', value: '0-100% RH' },
        { label: 'Accuracy', value: '±0.3°C, ±3% RH' },
        { label: 'Battery Life', value: 'Up to 2 years' }
      ]
    },
    'presence-sensor-fp1e': {
      id: 'presence-sensor-fp1e',
      name: 'Presence Sensor FP1E',
      image: presenceFP1E,
      description: 'Precise Detection for Optimal Spaces',
      fullDescription: 'mmWave radar sensor that detects human presence even when stationary. Perfect for lighting automation and room occupancy detection.',
      features: [
        'mmWave radar technology',
        'Detects stationary presence',
        'Zone configuration',
        'Privacy-friendly (no camera)',
        'Fast response time',
        'Adjustable sensitivity'
      ],
      specifications: [
        { label: 'Detection Range', value: '4m (configurable)' },
        { label: 'Field of View', value: '120°' },
        { label: 'Protocols', value: 'Zigbee 3.0' },
        { label: 'Power', value: 'USB-C 5V' }
      ]
    },
    'motion-light-sensor-p2': {
      id: 'motion-light-sensor-p2',
      name: 'Motion and Light Sensor P2',
      image: motionLightP2,
      description: 'Native Matter Support',
      fullDescription: 'Dual-function sensor with Matter protocol support for maximum compatibility. Detects motion and measures ambient light levels.',
      features: [
        'Matter protocol certified',
        'Motion detection',
        'Light level sensing',
        'Wide detection angle',
        'Long battery life',
        'Easy installation'
      ],
      specifications: [
        { label: 'Protocols', value: 'Matter, Thread' },
        { label: 'Detection Range', value: '7m, 170°' },
        { label: 'Battery', value: 'CR2450' },
        { label: 'Battery Life', value: 'Up to 2 years' }
      ]
    },
    'door-window-sensor-p2': {
      id: 'door-window-sensor-p2',
      name: 'Door and Window Sensor P2',
      image: doorWindowP2,
      description: 'Ultra-Compact Design',
      fullDescription: 'Smallest door/window sensor with Matter support. Monitor entry points and trigger automations with this tiny but powerful sensor.',
      features: [
        'Ultra-compact size',
        'Matter protocol support',
        'Open/close detection',
        'Instant notifications',
        'Long battery life',
        'Easy installation'
      ],
      specifications: [
        { label: 'Protocols', value: 'Matter, Thread' },
        { label: 'Dimensions', value: '28 x 11.5 x 8.5mm' },
        { label: 'Battery', value: 'CR1632' },
        { label: 'Battery Life', value: 'Up to 2 years' }
      ]
    },
    'presence-sensor-fp2': {
      id: 'presence-sensor-fp2',
      name: 'Presence Sensor FP2',
      image: presenceFP2,
      description: 'Advanced mmWave Radar Technology',
      fullDescription: 'Premium presence sensor with multi-zone detection. Track up to 5 people simultaneously with industry-leading accuracy.',
      features: [
        '5-person tracking',
        'Multi-zone detection',
        'Fall detection',
        'Privacy-preserving',
        'HomeKit support',
        'Edge AI processing'
      ],
      specifications: [
        { label: 'Detection Range', value: 'Up to 6m' },
        { label: 'Zones', value: 'Up to 30 custom zones' },
        { label: 'Protocols', value: 'Wi-Fi, Zigbee 3.0' },
        { label: 'Power', value: 'USB-C 5V/1A' }
      ]
    },
    'motion-sensor-p1': {
      id: 'motion-sensor-p1',
      name: 'Motion Sensor P1',
      image: motionP1,
      description: 'High Precision Motion Detection',
      fullDescription: 'Reliable PIR motion sensor with wide detection angle. Perfect for security systems and automation scenarios.',
      features: [
        'PIR motion detection',
        'Wide 170° detection',
        'Adjustable sensitivity',
        'Low power consumption',
        'Tamper alarm',
        'Compact design'
      ],
      specifications: [
        { label: 'Detection Range', value: '7m, 170°' },
        { label: 'Protocols', value: 'Zigbee 3.0' },
        { label: 'Battery', value: 'CR2450' },
        { label: 'Battery Life', value: 'Up to 2 years' }
      ]
    },
    'water-leak-sensor': {
      id: 'water-leak-sensor',
      name: 'Water Leak Sensor',
      image: waterLeak,
      description: 'Early Water Leak Detection',
      fullDescription: 'Protect your home from water damage with instant leak detection. Place near water heaters, washing machines, and under sinks.',
      features: [
        'Instant leak detection',
        'Loud alarm (90dB)',
        'Push notifications',
        'IPX7 waterproof',
        'Low battery alert',
        'Compact design'
      ],
      specifications: [
        { label: 'Protocols', value: 'Zigbee 3.0' },
        { label: 'Alarm Volume', value: '90dB' },
        { label: 'Battery', value: 'CR2032 x2' },
        { label: 'IP Rating', value: 'IPX7' }
      ]
    },
    'temp-humidity-sensor': {
      id: 'temp-humidity-sensor',
      name: 'Temperature & Humidity Sensor',
      image: tempHumidity,
      description: 'Swiss-Made Sensors for Accurate Monitoring',
      fullDescription: 'Professional-grade climate monitoring with Swiss Sensirion sensors. Perfect for maintaining optimal comfort and protecting valuables.',
      features: [
        'Swiss Sensirion sensor',
        'High accuracy readings',
        'Historical data tracking',
        'Automation triggers',
        'LCD display option',
        'Long battery life'
      ],
      specifications: [
        { label: 'Temperature Range', value: '-20°C to 60°C' },
        { label: 'Humidity Range', value: '0-100% RH' },
        { label: 'Accuracy', value: '±0.3°C, ±3% RH' },
        { label: 'Battery Life', value: 'Up to 2 years' }
      ]
    },
    'door-window-sensor-t1': {
      id: 'door-window-sensor-t1',
      name: 'Door and Window Sensor T1',
      image: doorWindowT1,
      description: 'Compact Door/Window Sensor',
      fullDescription: 'The T1 is a compact and reliable door/window sensor with extended battery life and improved wireless range.',
      features: [
        'Compact design',
        'Extended range',
        'Long battery life',
        'Fast response',
        'Easy mounting',
        'Smart automation'
      ],
      specifications: [
        { label: 'Protocols', value: 'Zigbee 3.0' },
        { label: 'Battery', value: 'CR1632' },
        { label: 'Battery Life', value: 'Up to 2 years' },
        { label: 'Detection', value: 'Open/Close' }
      ]
    },
    'door-window-sensor': {
      id: 'door-window-sensor',
      name: 'Door and Window Sensor',
      image: doorWindowSensor,
      description: 'Classic Door/Window Detection',
      fullDescription: 'The classic Aqara door and window sensor for reliable entry point monitoring and automation triggers.',
      features: [
        'Reliable detection',
        'Instant alerts',
        'Automation triggers',
        'Long battery life',
        'Easy installation',
        'Compact size'
      ],
      specifications: [
        { label: 'Protocols', value: 'Zigbee 3.0' },
        { label: 'Battery', value: 'CR1632' },
        { label: 'Battery Life', value: 'Up to 2 years' },
        { label: 'Gap Distance', value: 'Up to 22mm' }
      ]
    },
    'motion-sensor': {
      id: 'motion-sensor',
      name: 'Motion Sensor',
      image: motionSensor,
      description: 'Reliable Motion Detection',
      fullDescription: 'Classic PIR motion sensor for home automation and security. Reliable detection with adjustable sensitivity.',
      features: [
        'PIR motion detection',
        'Wide angle detection',
        'Adjustable sensitivity',
        'Battery powered',
        'Compact design',
        'Easy mounting'
      ],
      specifications: [
        { label: 'Detection Range', value: '7m, 170°' },
        { label: 'Protocols', value: 'Zigbee 3.0' },
        { label: 'Battery', value: 'CR2450' },
        { label: 'Battery Life', value: 'Up to 2 years' }
      ]
    },
    'smart-gas-detector': {
      id: 'smart-gas-detector',
      name: 'Smart Gas Detector',
      image: smartGasDetector,
      description: 'Natural Gas Leak Detection',
      fullDescription: 'Protect your home from gas leaks with instant detection and alerts. Can trigger automatic valve shutoff when paired with valve controller.',
      features: [
        'Natural gas detection',
        'Loud alarm (70dB)',
        'Push notifications',
        'Automation support',
        'Easy installation',
        'Self-test function'
      ],
      specifications: [
        { label: 'Detection', value: 'Natural gas (CH4)' },
        { label: 'Alarm Volume', value: '70dB' },
        { label: 'Protocols', value: 'Zigbee 3.0' },
        { label: 'Power', value: 'AC powered' }
      ]
    },
    'temp-humidity-sensor-t1': {
      id: 'temp-humidity-sensor-t1',
      name: 'Temperature & Humidity Sensor T1',
      image: tempHumidityT1,
      description: 'Compact Climate Monitoring',
      fullDescription: 'Compact T1 version of the temperature and humidity sensor with improved accuracy and wireless performance.',
      features: [
        'High precision sensor',
        'Compact design',
        'Long battery life',
        'Historical data',
        'Automation triggers',
        'LCD display'
      ],
      specifications: [
        { label: 'Temperature Range', value: '-20°C to 60°C' },
        { label: 'Humidity Range', value: '0-100% RH' },
        { label: 'Accuracy', value: '±0.3°C, ±3% RH' },
        { label: 'Battery Life', value: 'Up to 2 years' }
      ]
    },
    'vibration-sensor': {
      id: 'vibration-sensor',
      name: 'Vibration Sensor',
      image: vibrationSensor,
      description: 'Movement and Vibration Alert',
      fullDescription: 'Classic vibration sensor for security monitoring. Detects movement, tilting, and vibrations on doors, windows, and valuables.',
      features: [
        'Vibration detection',
        'Tilt sensing',
        'Drop detection',
        'Instant alerts',
        'Long battery life',
        'Versatile mounting'
      ],
      specifications: [
        { label: 'Detection', value: 'Vibration, Tilt, Drop' },
        { label: 'Protocols', value: 'Zigbee 3.0' },
        { label: 'Battery', value: 'CR2032' },
        { label: 'Battery Life', value: 'Up to 2 years' }
      ]
    },
    'tvoc-air-quality-monitor': {
      id: 'tvoc-air-quality-monitor',
      name: 'TVOC Air Quality Monitor',
      image: tvocMonitor,
      description: 'Indoor Air Quality Monitoring',
      fullDescription: 'Monitor indoor air quality with TVOC detection. Keep your home healthy by tracking volatile organic compounds.',
      features: [
        'TVOC detection',
        'Air quality index',
        'Temperature monitoring',
        'Humidity monitoring',
        'E-ink display',
        'Automation triggers'
      ],
      specifications: [
        { label: 'Detection', value: 'TVOC, Temperature, Humidity' },
        { label: 'Protocols', value: 'Zigbee 3.0' },
        { label: 'Display', value: 'E-ink' },
        { label: 'Power', value: 'USB-C' }
      ]
    },
    'water-leak-sensor-t1': {
      id: 'water-leak-sensor-t1',
      name: 'Water Leak Sensor T1',
      image: waterLeakT1,
      description: 'Advanced Water Detection',
      fullDescription: 'Updated T1 version with improved sensitivity and extended battery life for comprehensive water leak protection.',
      features: [
        'High sensitivity',
        'Instant alerts',
        'Extended battery',
        'IP67 waterproof',
        'Compact design',
        'Easy placement'
      ],
      specifications: [
        { label: 'Protocols', value: 'Zigbee 3.0' },
        { label: 'Battery', value: 'CR2032' },
        { label: 'Battery Life', value: 'Up to 3 years' },
        { label: 'IP Rating', value: 'IP67' }
      ]
    },

    // Smart Home Controller Products
    'cube-t1-pro': {
      id: 'cube-t1-pro',
      name: 'Cube T1 Pro',
      image: cubeT1Pro,
      description: 'Six-Sided Controller',
      fullDescription: 'Innovative 6-sided smart controller. Each side and action triggers different scenes - flip, shake, rotate, tap for intuitive control.',
      features: [
        '6 sides for different actions',
        'Gesture recognition',
        'Scene triggering',
        'Rotate for dimming',
        'Shake for alerts',
        'Premium build quality'
      ],
      specifications: [
        { label: 'Protocols', value: 'Zigbee 3.0' },
        { label: 'Battery', value: 'CR2450' },
        { label: 'Actions', value: 'Flip, Shake, Rotate, Tap' },
        { label: 'Material', value: 'Aluminum alloy' }
      ]
    },
    'smart-plug': {
      id: 'smart-plug',
      name: 'Smart Plug',
      image: smartPlug,
      description: 'Smart Power Control',
      fullDescription: 'Transform any device into a smart device. Monitor power consumption, set schedules, and control remotely.',
      features: [
        'Remote on/off control',
        'Power monitoring',
        'Energy statistics',
        'Scheduling and timers',
        'Overload protection',
        'Compact design'
      ],
      specifications: [
        { label: 'Max Load', value: '2500W (10A)' },
        { label: 'Protocols', value: 'Zigbee 3.0' },
        { label: 'Voltage', value: '100-250V AC' },
        { label: 'Size', value: 'Compact, doesn\'t block adjacent outlets' }
      ]
    },
    'cube': {
      id: 'cube',
      name: 'Cube',
      image: cube,
      description: 'Classic Gesture Controller',
      fullDescription: 'The original Aqara Cube controller. Use intuitive gestures like flip, rotate, and shake to control your smart home devices.',
      features: [
        'Gesture control',
        'Flip actions',
        'Rotation control',
        'Shake detection',
        'Scene triggering',
        'Battery powered'
      ],
      specifications: [
        { label: 'Protocols', value: 'Zigbee 3.0' },
        { label: 'Battery', value: 'CR2450' },
        { label: 'Actions', value: 'Flip, Rotate, Shake, Tap' },
        { label: 'Battery Life', value: 'Up to 2 years' }
      ]
    },
    'smart-plug-eu': {
      id: 'smart-plug-eu',
      name: 'Smart Plug (EU)',
      image: smartPlugEU,
      description: 'European Smart Power Control',
      fullDescription: 'European version of the smart plug with power monitoring and remote control capabilities.',
      features: [
        'Remote control',
        'Power monitoring',
        'Scheduling',
        'Energy statistics',
        'Overload protection',
        'EU plug type'
      ],
      specifications: [
        { label: 'Max Load', value: '2300W (10A)' },
        { label: 'Protocols', value: 'Zigbee 3.0' },
        { label: 'Voltage', value: '220-240V AC' },
        { label: 'Plug Type', value: 'EU Type F' }
      ]
    },
    'dimmer-switch-h2-eu': {
      id: 'dimmer-switch-h2-eu',
      name: 'Dimmer Switch H2 EU',
      image: dimmerSwitchH2EU,
      description: 'European Dimmer Switch',
      fullDescription: 'Smart dimmer switch for European installations. Control brightness levels smoothly for the perfect ambiance.',
      features: [
        'Smooth dimming',
        'LED compatible',
        'Touch controls',
        'Scene integration',
        'Remote control',
        'No flicker'
      ],
      specifications: [
        { label: 'Max Load', value: '400W LED' },
        { label: 'Protocols', value: 'Zigbee 3.0' },
        { label: 'Voltage', value: '220-240V AC' },
        { label: 'Standard', value: 'EU Type' }
      ]
    },
    'dual-relay-module-t2': {
      id: 'dual-relay-module-t2',
      name: 'Dual Relay Module T2',
      image: dualRelayT2,
      description: 'Dual Channel Relay Control',
      fullDescription: 'Control two independent circuits with a single module. Perfect for controlling lights, fans, and other devices.',
      features: [
        'Dual channels',
        'Independent control',
        'Hidden installation',
        'Energy monitoring',
        'Automation ready',
        'Compact design'
      ],
      specifications: [
        { label: 'Channels', value: '2' },
        { label: 'Max Load', value: '2500W per channel' },
        { label: 'Protocols', value: 'Zigbee 3.0' },
        { label: 'Installation', value: 'In-wall' }
      ]
    },
    'floor-heating-thermostat-w500': {
      id: 'floor-heating-thermostat-w500',
      name: 'Floor Heating Thermostat W500',
      image: floorThermostatW500,
      description: 'Smart Floor Heating Control',
      fullDescription: 'Control your floor heating system with precision. Program schedules and maintain optimal comfort levels.',
      features: [
        'Floor heating control',
        'Temperature scheduling',
        'Touch display',
        'Energy saving modes',
        'Remote control',
        'Frost protection'
      ],
      specifications: [
        { label: 'Display', value: 'LCD Touch' },
        { label: 'Protocols', value: 'Zigbee 3.0' },
        { label: 'Temperature Range', value: '5-35°C' },
        { label: 'Power', value: 'AC 100-240V' }
      ]
    },
    'radiator-thermostat-e1': {
      id: 'radiator-thermostat-e1',
      name: 'Radiator Thermostat E1',
      image: radiatorE1,
      description: 'Smart Radiator Control',
      fullDescription: 'Smart radiator valve for individual room temperature control. Save energy while maintaining comfort.',
      features: [
        'Individual room control',
        'Temperature scheduling',
        'Window detection',
        'Frost protection',
        'Easy installation',
        'Long battery life'
      ],
      specifications: [
        { label: 'Connection', value: 'M30 x 1.5mm' },
        { label: 'Protocols', value: 'Zigbee 3.0' },
        { label: 'Battery', value: '2x AA' },
        { label: 'Battery Life', value: 'Up to 1 year' }
      ]
    },
    'radiator-thermostat-w600': {
      id: 'radiator-thermostat-w600',
      name: 'Radiator Thermostat W600',
      image: radiatorW600,
      description: 'Advanced Radiator Control',
      fullDescription: 'Advanced radiator thermostat with additional features for precise temperature management.',
      features: [
        'Precise temperature control',
        'Adaptive scheduling',
        'Open window detection',
        'Geofencing support',
        'Voice control',
        'Energy reports'
      ],
      specifications: [
        { label: 'Connection', value: 'M30 x 1.5mm' },
        { label: 'Protocols', value: 'Zigbee 3.0' },
        { label: 'Display', value: 'LCD' },
        { label: 'Battery Life', value: 'Up to 18 months' }
      ]
    },
    'shutter-switch-h2-eu': {
      id: 'shutter-switch-h2-eu',
      name: 'Shutter Switch H2 EU',
      image: shutterSwitchH2EU,
      description: 'European Shutter Control',
      fullDescription: 'Smart control for roller shutters and blinds. Set positions, schedules, and automate based on time or sensors.',
      features: [
        'Shutter control',
        'Position memory',
        'Scheduling',
        'Sun protection automation',
        'Voice control',
        'Matter certified'
      ],
      specifications: [
        { label: 'Max Load', value: '1500W' },
        { label: 'Protocols', value: 'Matter, Zigbee 3.0' },
        { label: 'Voltage', value: '220-240V AC' },
        { label: 'Standard', value: 'EU Type' }
      ]
    },
    'single-switch-module-t1-no-neutral': {
      id: 'single-switch-module-t1-no-neutral',
      name: 'Single Switch Module T1 (No Neutral)',
      image: singleSwitchT1NoNeutral,
      description: 'Retrofit Switch Module',
      fullDescription: 'Hidden switch module that works without neutral wire. Perfect for retrofitting existing switches.',
      features: [
        'No neutral required',
        'Hidden installation',
        'Works with existing switches',
        'Remote control',
        'Scheduling',
        'Scene support'
      ],
      specifications: [
        { label: 'Max Load', value: '800W' },
        { label: 'Protocols', value: 'Zigbee 3.0' },
        { label: 'Neutral Wire', value: 'Not required' },
        { label: 'Installation', value: 'Behind existing switch' }
      ]
    },
    'single-switch-module-t1-with-neutral': {
      id: 'single-switch-module-t1-with-neutral',
      name: 'Single Switch Module T1 (With Neutral)',
      image: singleSwitchT1WithNeutral,
      description: 'Switch Module with Neutral',
      fullDescription: 'Hidden switch module requiring neutral wire for enhanced functionality and higher loads.',
      features: [
        'Higher load capacity',
        'Hidden installation',
        'Power monitoring',
        'Remote control',
        'Scheduling',
        'More stable operation'
      ],
      specifications: [
        { label: 'Max Load', value: '1250W' },
        { label: 'Protocols', value: 'Zigbee 3.0' },
        { label: 'Neutral Wire', value: 'Required' },
        { label: 'Power Monitoring', value: 'Yes' }
      ]
    },
    'smart-pet-feeder-c1': {
      id: 'smart-pet-feeder-c1',
      name: 'Smart Pet Feeder C1',
      image: smartPetFeederC1,
      description: 'Automated Pet Feeding',
      fullDescription: 'Keep your pets fed on schedule with the smart pet feeder. Set portions, schedules, and monitor feeding remotely.',
      features: [
        'Scheduled feeding',
        'Portion control',
        'Remote feeding',
        'Food level monitoring',
        'Voice recording',
        'Fresh food storage'
      ],
      specifications: [
        { label: 'Capacity', value: '4L' },
        { label: 'Portions', value: '1-10 portions per meal' },
        { label: 'Connectivity', value: 'Wi-Fi 2.4GHz' },
        { label: 'Power', value: 'AC adapter + battery backup' }
      ]
    },
    'thermostat-w400': {
      id: 'thermostat-w400',
      name: 'Thermostat W400',
      image: thermostatW400,
      description: 'Smart Climate Control',
      fullDescription: 'Smart thermostat for HVAC control. Maintain optimal temperature while saving energy.',
      features: [
        'HVAC control',
        'Touch display',
        'Scheduling',
        'Energy saving',
        'Remote access',
        'Geofencing'
      ],
      specifications: [
        { label: 'Display', value: 'LCD Touch' },
        { label: 'Protocols', value: 'Zigbee 3.0' },
        { label: 'Control', value: 'Heating/Cooling' },
        { label: 'Power', value: '24V AC or battery' }
      ]
    },
    'valve-controller-t1': {
      id: 'valve-controller-t1',
      name: 'Valve Controller T1',
      image: valveControllerT1,
      description: 'Smart Water Valve Control',
      fullDescription: 'Automatically shut off water supply in case of leaks. Pairs with water leak sensors for complete protection.',
      features: [
        'Automatic shutoff',
        'Manual control',
        'Leak sensor pairing',
        'Remote control',
        'Status monitoring',
        'Easy installation'
      ],
      specifications: [
        { label: 'Valve Type', value: 'Ball valve' },
        { label: 'Protocols', value: 'Zigbee 3.0' },
        { label: 'Pipe Size', value: '1/2" - 1"' },
        { label: 'Power', value: 'DC adapter' }
      ]
    },
    'wall-outlet-h2-eu': {
      id: 'wall-outlet-h2-eu',
      name: 'Wall Outlet H2 EU',
      image: wallOutletH2EU,
      description: 'European Smart Outlet',
      fullDescription: 'Smart wall outlet for European installations with Matter support for universal compatibility.',
      features: [
        'Matter certified',
        'Power monitoring',
        'Remote control',
        'Scheduling',
        'Child safety',
        'Overload protection'
      ],
      specifications: [
        { label: 'Max Load', value: '3680W (16A)' },
        { label: 'Protocols', value: 'Matter, Zigbee 3.0' },
        { label: 'Voltage', value: '220-240V AC' },
        { label: 'Standard', value: 'EU Type F' }
      ]
    },
    'wall-outlet-h2-uk': {
      id: 'wall-outlet-h2-uk',
      name: 'Wall Outlet H2 UK',
      image: wallOutletH2UK,
      description: 'UK Smart Outlet',
      fullDescription: 'Smart wall outlet for UK installations with comprehensive safety features.',
      features: [
        'UK standard',
        'Power monitoring',
        'Remote control',
        'USB ports',
        'Child safety shutter',
        'Surge protection'
      ],
      specifications: [
        { label: 'Max Load', value: '3000W (13A)' },
        { label: 'Protocols', value: 'Zigbee 3.0' },
        { label: 'Voltage', value: '220-240V AC' },
        { label: 'Standard', value: 'UK BS 1363' }
      ]
    },
    'wireless-mini-switch-t1': {
      id: 'wireless-mini-switch-t1',
      name: 'Wireless Mini Switch T1',
      image: wirelessMiniSwitchT1,
      description: 'Compact Wireless Button',
      fullDescription: 'Ultra-compact wireless switch for convenient control anywhere. Multiple actions from a single button.',
      features: [
        'Ultra compact',
        'Multiple click actions',
        'Battery powered',
        'Magnetic mount',
        'Scene control',
        'Long battery life'
      ],
      specifications: [
        { label: 'Actions', value: 'Single, Double, Long press' },
        { label: 'Protocols', value: 'Zigbee 3.0' },
        { label: 'Battery', value: 'CR2032' },
        { label: 'Battery Life', value: 'Up to 2 years' }
      ]
    },
    'wireless-mini-switch': {
      id: 'wireless-mini-switch',
      name: 'Wireless Mini Switch',
      image: wirelessMiniSwitch,
      description: 'Portable Wireless Control',
      fullDescription: 'Original wireless mini switch for flexible smart home control. Place anywhere for convenient access.',
      features: [
        'Portable design',
        'Multiple actions',
        'No wiring needed',
        'Scene triggering',
        'Easy setup',
        'Long lasting battery'
      ],
      specifications: [
        { label: 'Actions', value: 'Single, Double, Long press' },
        { label: 'Protocols', value: 'Zigbee 3.0' },
        { label: 'Battery', value: 'CR2032' },
        { label: 'Battery Life', value: 'Up to 2 years' }
      ]
    },
    'smart-20a-switch-h1-sea': {
      id: 'smart-20a-switch-h1-sea',
      name: 'Smart 20A Switch H1 (SEA)',
      image: smart20ASwitchH1,
      description: 'High Power Smart Switch',
      fullDescription: 'High power smart switch for air conditioners and water heaters. SEA version for regional compatibility.',
      features: [
        'High power capacity',
        '20A rating',
        'LED indicator',
        'Remote control',
        'Scheduling',
        'Overload protection'
      ],
      specifications: [
        { label: 'Max Load', value: '4400W (20A)' },
        { label: 'Protocols', value: 'Zigbee 3.0' },
        { label: 'Voltage', value: '220-240V AC' },
        { label: 'Region', value: 'Southeast Asia' }
      ]
    },
    'light-switch-h2-us': {
      id: 'light-switch-h2-us',
      name: 'Light Switch H2 US',
      image: lightSwitchH2US,
      description: 'US Standard Light Switch',
      fullDescription: 'Smart light switch for US installations with paddle-style design familiar to American homeowners.',
      features: [
        'US standard design',
        'Paddle switch',
        'Remote control',
        'Scene integration',
        'Voice control',
        'LED indicator'
      ],
      specifications: [
        { label: 'Max Load', value: '800W LED' },
        { label: 'Protocols', value: 'Zigbee 3.0' },
        { label: 'Voltage', value: '110-120V AC' },
        { label: 'Standard', value: 'US Decora' }
      ]
    },
    'smart-wall-switch-h1-eu-no-neutral': {
      id: 'smart-wall-switch-h1-eu-no-neutral',
      name: 'Smart Wall Switch H1 EU (No Neutral)',
      image: smartWallSwitchH1EUNoNeutral,
      description: 'EU Switch No Neutral',
      fullDescription: 'European smart wall switch that works without neutral wire for retrofit installations. Perfect for upgrading traditional switches without rewiring your home.',
      features: [
        'No neutral required',
        'EU standard design',
        'Round & square wall box support',
        'Award-winning design',
        'Remote control',
        'Voice assistant compatible'
      ],
      detailedFeatures: [
        {
          title: 'No Neutral Wire Required',
          description: 'Designed for easy retrofit installation in homes without neutral wiring. Simply replace your existing switch without complex rewiring or electrical modifications.'
        },
        {
          title: 'Dual Wall Box Support',
          description: 'Compatible with both round European wall boxes and standard 86mm square boxes. First Aqara switch offering such versatile installation options for maximum compatibility.'
        },
        {
          title: 'Zigbee 3.0 Protocol',
          description: 'Enjoy the benefits of the fastest, most stable, and energy-efficient smart home technology. Reliable wireless connectivity with extended range and low power consumption.'
        },
        {
          title: 'Award-Winning Premium Design',
          description: 'Features award-winning design with metal frame construction for enhanced durability. Clean, minimalist aesthetic preferred by users worldwide with short button travel for responsive control.'
        },
        {
          title: 'Convert to Wireless Switch',
          description: 'Remap physical buttons to control other devices while the light is controlled by automations. Gain extra "wireless switch" functionality without additional hardware.'
        },
        {
          title: 'Advanced Protection Features',
          description: 'Built-in overheat protection ensures safe operation. Meets highest European safety standards including CE and EAC certifications for peace of mind.'
        },
        {
          title: '2-Way Switch Setup Support',
          description: 'Upgrade existing 2-way switch setups using Wall Switch H1 EU with Wireless Switch H1. Place wireless component on existing wall box or any flat surface with adhesive.'
        },
        {
          title: 'Configurable LED Behavior',
          description: 'Customize LED indicator behavior via Aqara Home app. Turn off completely, illuminate when switch is on, or reverse the behavior to suit your preference. Configure power-off memory to prevent lights turning on unexpectedly after power outages.'
        }
      ],
      accessMethods: [
        {
          name: 'Physical Rocker Button',
          description: 'Traditional rocker-style button with responsive tactile feedback'
        },
        {
          name: 'Aqara Home App',
          description: 'Remote control and scheduling via mobile application'
        },
        {
          name: 'Apple HomeKit',
          description: 'Native integration with Apple Home app and Siri voice commands'
        },
        {
          name: 'Google Assistant',
          description: 'Voice control through Google Home ecosystem'
        },
        {
          name: 'Amazon Alexa',
          description: 'Hands-free control via Alexa voice commands'
        },
        {
          name: 'IFTTT Automation',
          description: 'Create custom automations connecting to thousands of services'
        },
        {
          name: 'Scene Activation',
          description: 'Trigger multi-device scenes with single button press'
        },
        {
          name: '2-Way Control',
          description: 'Control from multiple locations using Wireless Switch H1 pairing'
        }
      ],
      specifications: [
        { label: 'Max Load', value: '800W LED / 1500W incandescent' },
        { label: 'Protocols', value: 'Zigbee 3.0' },
        { label: 'Standard', value: 'EU Type (round & square)' },
        { label: 'Neutral Wire', value: 'Not required' },
        { label: 'Voltage', value: '220-240V AC' },
        { label: 'Control Methods', value: 'Physical button, app, voice (Siri/Alexa/Google), automation, 2-way setup' },
        { label: 'Certifications', value: 'CE, EAC' },
        { label: 'Hub Required', value: 'Yes (Zigbee 3.0 hub)' }
      ]
    },

    // Switch Products
    'touchscreen-dial-v1-eu': {
      id: 'touchscreen-dial-v1-eu',
      name: 'Touchscreen Dial V1 EU',
      image: touchscreenDialV1EU,
      hero: touchscreenDialV1EUHero,
      featureImages: [touchscreenDialV1EUFeature],
      description: 'Advanced Touch Control with Dial Interface',
      fullDescription: 'The Touchscreen Dial V1 EU combines an intuitive touchscreen with a rotary dial for precise control of your smart home. Perfect for dimming lights, adjusting temperature, and controlling scenes with elegant precision.',
      features: [
        'Full-color touchscreen display',
        'Rotary dial for precise adjustment',
        'Customizable scene buttons',
        'Multi-device control',
        'Ambient light sensor',
        'Sleek European design'
      ],
      detailedFeatures: [
        {
          title: 'Intuitive Touchscreen Interface',
          description: 'High-resolution 2.1" IPS display provides crisp, colorful visualization of your smart home controls. Navigate menus easily with responsive touch technology and clear visual feedback.'
        },
        {
          title: 'Precision Rotary Dial',
          description: 'Physical dial control offers tactile feedback for precise adjustments. Perfect for dimming lights, adjusting temperature, or controlling volume with smooth, accurate rotation.'
        },
        {
          title: 'Multi-Device Control Hub',
          description: 'Centralized control point for all your Zigbee 3.0 devices. Switch between controlling lights, thermostats, curtains, and more from a single elegant interface.'
        },
        {
          title: 'Customizable Scene Shortcuts',
          description: 'Program quick-access buttons for your favorite scenes and automations. Activate complex multi-device scenarios with a single tap.'
        },
        {
          title: 'Ambient Light Adaptation',
          description: 'Built-in light sensor automatically adjusts screen brightness based on room lighting. Ensures perfect visibility day or night without manual adjustment.'
        },
        {
          title: 'European Standard Design',
          description: 'Designed specifically for EU-type wall boxes with premium materials and build quality. Flush-mounted design integrates seamlessly with European interiors.'
        },
        {
          title: 'Voice Assistant Integration',
          description: 'Works with Apple HomeKit, Google Assistant, and Amazon Alexa for hands-free control. Combine touch, dial, and voice for ultimate flexibility.'
        },
        {
          title: 'Real-Time Status Display',
          description: 'View current temperature, humidity, and device states at a glance. Stay informed about your smart home status directly from the switch panel.'
        }
      ],
      accessMethods: [
        {
          name: 'Touchscreen Control',
          description: 'Direct touch interface for navigating menus and activating devices'
        },
        {
          name: 'Rotary Dial',
          description: 'Physical dial for precise dimming, temperature, and volume adjustments'
        },
        {
          name: 'Scene Buttons',
          description: 'Programmable quick-access buttons for instant scene activation'
        },
        {
          name: 'App Control',
          description: 'Remote management via Aqara Home mobile application'
        },
        {
          name: 'Voice Control',
          description: 'Hands-free operation through Siri, Alexa, or Google Assistant'
        },
        {
          name: 'Automation',
          description: 'Automated adjustments based on time, sensors, or other triggers'
        }
      ],
      specifications: [
        { label: 'Display', value: '2.1" IPS Touchscreen' },
        { label: 'Protocols', value: 'Zigbee 3.0, Wi-Fi' },
        { label: 'Voltage', value: '100-240V AC' },
        { label: 'Installation', value: 'EU standard box' },
        { label: 'Control Methods', value: 'Touchscreen, rotary dial, scene buttons, app control, voice control, automation' },
        { label: 'Compatibility', value: 'Apple HomeKit, Google Assistant, Amazon Alexa, IFTTT' }
      ]
    },
    'smart-wall-switch-h1-triple-neutral': {
      id: 'smart-wall-switch-h1-triple-neutral',
      name: 'Smart Wall Switch H1 Triple (With Neutral)',
      image: wallSwitchH1TripleNeutral,
      hero: wallSwitchH1TripleNeutralHero,
      featureImages: [wallSwitchH1TripleNeutralFeature],
      description: 'Triple Gang Switch with Neutral Wire',
      fullDescription: 'Control three separate circuits with one elegant switch. The H1 Triple with neutral wire support provides reliable smart control for multi-zone lighting setups with advanced features like power monitoring and repeater functionality.',
      features: [
        'Triple gang configuration',
        'Zigbee repeater function',
        'Power monitoring',
        'Award-winning design',
        'Voice assistant compatible',
        'Overload protection'
      ],
      detailedFeatures: [
        {
          title: '86mm Square Wall Box Support',
          description: 'Designed for standard 86mm square wall boxes commonly used worldwide. Professional installation ensures seamless integration with existing electrical infrastructure.'
        },
        {
          title: 'Zigbee 3.0 with Repeater Function',
          description: 'Enjoy the fastest, most stable smart home technology. With Neutral version includes router (repeater) functionality that automatically extends your Zigbee network for improved coverage and reliability.'
        },
        {
          title: 'Premium Build & Metal Frame',
          description: 'Award-winning design featuring metal frame construction for enhanced rigidity and durability. Clean, minimalist aesthetic with short button travel for responsive, satisfying control.'
        },
        {
          title: 'Convert to Wireless Switch Function',
          description: 'Remap switch buttons to control other devices (roller shades, scenes, etc.) while light is controlled by automations. Gain extra wireless switch functionality without additional hardware.'
        },
        {
          title: 'Advanced Protection Features',
          description: 'Comprehensive safety with overheat and overload protection. Multiple protection levels ensure safe operation and compliance with highest safety standards.'
        },
        {
          title: 'Real-Time Power Monitoring',
          description: 'Monitor power consumption and generate detailed power curve diagrams. Track which devices consume most energy and identify opportunities for efficiency improvements.'
        },
        {
          title: 'Universal Smart Home Compatibility',
          description: 'Works with Apple HomeKit, Google Assistant, Amazon Alexa, and IFTTT. Integrate seamlessly into your existing smart home ecosystem for ultimate flexibility.'
        },
        {
          title: '2-Way Setup with Wireless Switch H1',
          description: 'Upgrade existing 2-way setups by pairing with Wireless Switch H1. Place wireless component on existing wall box or any flat surface using adhesive tape for flexible installation.'
        }
      ],
      accessMethods: [
        {
          name: 'Physical Rocker Buttons',
          description: 'Three independent rocker buttons for direct tactile control of each circuit'
        },
        {
          name: 'Aqara Home App',
          description: 'Individual or group control of all three channels via mobile app'
        },
        {
          name: 'Apple HomeKit',
          description: 'Native integration with Apple Home and Siri voice control'
        },
        {
          name: 'Google Assistant',
          description: 'Voice commands through Google Home ecosystem'
        },
        {
          name: 'Amazon Alexa',
          description: 'Hands-free operation via Alexa voice assistant'
        },
        {
          name: 'Automation',
          description: 'Schedule, sensor-triggered, and condition-based automated control'
        },
        {
          name: 'Scene Activation',
          description: 'Trigger complex multi-device scenes from physical buttons'
        },
        {
          name: '2-Way Control',
          description: 'Control from multiple locations using Wireless Switch H1 pairing'
        }
      ],
      specifications: [
        { label: 'Gangs', value: '3' },
        { label: 'Protocols', value: 'Zigbee 3.0 (with repeater)' },
        { label: 'Max Load', value: '800W per channel' },
        { label: 'Installation', value: 'Requires neutral wire, 86mm square box' },
        { label: 'Power Monitoring', value: 'Yes (real-time & historical)' },
        { label: 'Control Methods', value: 'Physical buttons (3), app, voice (Siri/Alexa/Google), automation, scenes, 2-way' },
        { label: 'Protection', value: 'Overheat, overload' },
        { label: 'Hub Required', value: 'Yes (Zigbee 3.0 hub)' }
      ]
    },
    'smart-wall-switch-z1-pro': {
      id: 'smart-wall-switch-z1-pro',
      name: 'Smart Wall Switch Z1 Pro',
      image: wallSwitchZ1Pro,
      hero: wallSwitchZ1ProHero,
      featureImages: [wallSwitchZ1ProFeature],
      description: 'Professional Grade Smart Wall Switch',
      fullDescription: 'The Z1 Pro represents the pinnacle of smart switch technology with premium materials, advanced features, and professional-grade reliability for demanding installations.',
      features: [
        'Premium build quality',
        'Advanced touch controls',
        'Multi-protocol support',
        'Energy monitoring',
        'Scene programming',
        'Professional installation ready'
      ],
      detailedFeatures: [
        {
          title: 'Premium Construction Quality',
          description: 'Tempered glass panel with reinforced metal frame provides exceptional durability. Professional-grade components ensure long-lasting reliable operation.'
        },
        {
          title: 'Advanced Touch Control Technology',
          description: 'High-sensitivity capacitive touch provides instant, reliable response. Waterproof touch surface resists moisture and maintains performance over time.'
        },
        {
          title: 'Multi-Protocol Support',
          description: 'Zigbee 3.0 and Thread compatibility ensures future-proof connectivity. Work with current and next-generation smart home platforms seamlessly.'
        },
        {
          title: 'High-Capacity Power Handling',
          description: 'Supports up to 1250W of connected load - 50% more than standard switches. Handle demanding lighting installations and high-power devices.'
        },
        {
          title: 'Real-Time Energy Monitoring',
          description: 'Advanced metering tracks power consumption with precision. Generate detailed reports to optimize energy usage and reduce costs.'
        },
        {
          title: 'Advanced Scene Programming',
          description: 'Create sophisticated multi-device automations with conditional logic. Program complex scenarios for ultimate smart home control.'
        },
        {
          title: 'Wide Voltage Compatibility',
          description: 'Operates across 100-250V AC range for global compatibility. Single product works in virtually any country or region.'
        },
        {
          title: 'Professional Installation Features',
          description: 'Robust terminal connections and clear labeling simplify installation. Designed for professional electricians with quality they demand.'
        }
      ],
      accessMethods: [
        {
          name: 'Touch Control',
          description: 'Advanced capacitive touch with waterproof surface'
        },
        {
          name: 'Aqara Home App',
          description: 'Full remote management and energy monitoring'
        },
        {
          name: 'Voice Assistants',
          description: 'Apple HomeKit, Google Assistant, Amazon Alexa support'
        },
        {
          name: 'Scene Control',
          description: 'Complex multi-device scene activation'
        },
        {
          name: 'Advanced Automation',
          description: 'Conditional logic and sophisticated scheduling'
        },
        {
          name: 'Energy Management',
          description: 'Power consumption tracking and optimization'
        }
      ],
      specifications: [
        { label: 'Protocols', value: 'Zigbee 3.0, Thread' },
        { label: 'Max Load', value: '1250W' },
        { label: 'Voltage', value: '100-250V AC' },
        { label: 'Material', value: 'Tempered glass panel, metal frame' },
        { label: 'Control Methods', value: 'Touch control, app, voice (Siri/Alexa/Google), scenes, automation, energy management' },
        { label: 'Energy Monitoring', value: 'Yes (real-time & historical)' },
        { label: 'Hub Required', value: 'Yes (Zigbee 3.0 or Thread hub)' }
      ]
    },
    'smart-wall-switch-h1-eu-neutral': {
      id: 'smart-wall-switch-h1-eu-neutral',
      name: 'Smart Wall Switch H1 EU (With Neutral)',
      image: wallSwitchH1EUNeutral,
      hero: wallSwitchH1EUNeutralHero,
      featureImages: [wallSwitchH1EUNeutralFeature],
      description: 'European Switch with Neutral Wire',
      fullDescription: 'Designed specifically for European electrical systems, this switch requires neutral wire connection for optimal performance and compatibility with LED lighting. Features enhanced power monitoring and repeater functionality.',
      features: [
        'EU standard design',
        'Neutral wire required',
        'Zigbee repeater function',
        'Power monitoring',
        'Overload protection',
        'Voice control support'
      ],
      detailedFeatures: [
        {
          title: 'Dual Wall Box Compatibility',
          description: 'Compatible with both round European wall boxes and standard 86mm square boxes. First Aqara switch offering such versatile installation options.'
        },
        {
          title: 'Zigbee 3.0 with Repeater Function',
          description: 'With Neutral version includes router (repeater) functionality that automatically extends Zigbee network range. Improves overall network stability and coverage.'
        },
        {
          title: 'Real-Time Power Monitoring',
          description: 'Track power consumption and generate detailed energy usage reports. Identify high-consuming devices and optimize for efficiency.'
        },
        {
          title: 'Award-Winning Premium Design',
          description: 'Metal frame construction with clean, minimalist aesthetic. Award-winning design provides durability and sophisticated appearance.'
        },
        {
          title: 'Enhanced Safety Protection',
          description: 'Comprehensive overheat and overload protection ensures safe operation. Multiple protection levels meet highest European safety standards.'
        },
        {
          title: 'High LED Compatibility',
          description: 'Optimized for LED loads up to 800W with excellent dimming performance. Also handles 1500W incandescent loads for versatility.'
        },
        {
          title: 'Wireless Switch Conversion',
          description: 'Remap physical button to control other devices while light is automated. Gain extra wireless switch without additional hardware.'
        },
        {
          title: '2-Way Setup with Wireless H1',
          description: 'Pair with Wireless Switch H1 for easy 2-way control. Place wireless component anywhere using adhesive or wall box mounting.'
        }
      ],
      accessMethods: [
        {
          name: 'Physical Rocker',
          description: 'Traditional rocker button with responsive feedback'
        },
        {
          name: 'Aqara Home App',
          description: 'Remote control with power monitoring and scheduling'
        },
        {
          name: 'Apple HomeKit',
          description: 'Native integration with Apple Home and Siri'
        },
        {
          name: 'Google Assistant',
          description: 'Voice control via Google Home ecosystem'
        },
        {
          name: 'Amazon Alexa',
          description: 'Hands-free operation with Alexa voice commands'
        },
        {
          name: 'IFTTT',
          description: 'Advanced automation connecting thousands of services'
        },
        {
          name: '2-Way Control',
          description: 'Multi-location control with Wireless Switch H1'
        },
        {
          name: 'Scene Activation',
          description: 'Trigger multi-device scenes from physical button'
        }
      ],
      specifications: [
        { label: 'Standard', value: 'EU Type (round & square)' },
        { label: 'Protocols', value: 'Zigbee 3.0 (with repeater)' },
        { label: 'Max Load', value: '800W LED / 1500W incandescent' },
        { label: 'Voltage', value: '220-240V AC' },
        { label: 'Neutral Wire', value: 'Required' },
        { label: 'Power Monitoring', value: 'Yes' },
        { label: 'Control Methods', value: 'Physical button, app, voice (Siri/Alexa/Google), IFTTT, 2-way, scenes' },
        { label: 'Protection', value: 'Overheat, overload' },
        { label: 'Hub Required', value: 'Yes (Zigbee 3.0 hub)' }
      ]
    },
    'smart-wall-switch-h1-eu-grey': {
      id: 'smart-wall-switch-h1-eu-grey',
      name: 'Smart Wall Switch H1 EU Grey',
      image: wallSwitchH1EUGrey,
      hero: wallSwitchH1EUGreyHero,
      featureImages: [wallSwitchH1EUGreyFeature],
      description: 'Grey Finish European Switch',
      fullDescription: 'Elegant grey finish smart switch that complements modern interior designs. All the smart features of the H1 EU series in a sophisticated grey color. No neutral wire required for easy retrofit.',
      features: [
        'Premium grey finish',
        'No neutral wire required',
        'EU wall box compatible',
        'Award-winning design',
        'App and voice control',
        'Minimalist design'
      ],
      detailedFeatures: [
        {
          title: 'Sophisticated Grey Finish',
          description: 'Premium grey color complements modern interior design trends. Subtle, elegant appearance integrates seamlessly with contemporary decor.'
        },
        {
          title: 'No Neutral Wire Installation',
          description: 'Designed for retrofit installation without neutral wiring. Replace existing switches to gain smart functionality without rewiring.'
        },
        {
          title: 'Dual Wall Box Support',
          description: 'Compatible with round European and 86mm square wall boxes. Versatile installation options for maximum compatibility.'
        },
        {
          title: 'Award-Winning Design',
          description: 'Shares award-winning design language of H1 EU series. Metal frame construction ensures rigidity and premium feel.'
        },
        {
          title: 'Zigbee 3.0 Technology',
          description: 'Latest Zigbee 3.0 protocol provides fast, stable connectivity. Energy-efficient wireless communication with extended range.'
        },
        {
          title: 'Touch-Sensitive Buttons',
          description: 'Responsive touch-sensitive rocker provides satisfying tactile feedback. Short button travel ensures quick, precise control.'
        },
        {
          title: 'Smart Home Integration',
          description: 'Works with Apple HomeKit, Google Assistant, Amazon Alexa, and IFTTT. Voice control and app management for complete flexibility.'
        },
        {
          title: 'Scene Integration',
          description: 'Integrate into multi-device scenes for coordinated control. Trigger complex automations with single button press.'
        }
      ],
      accessMethods: [
        {
          name: 'Touch-Sensitive Rocker',
          description: 'Responsive touch button with tactile feedback'
        },
        {
          name: 'Aqara Home App',
          description: 'Remote control and scheduling via mobile app'
        },
        {
          name: 'Apple HomeKit',
          description: 'Full integration with Apple Home and Siri'
        },
        {
          name: 'Google Assistant',
          description: 'Voice commands through Google Home'
        },
        {
          name: 'Amazon Alexa',
          description: 'Hands-free control via Alexa devices'
        },
        {
          name: 'IFTTT',
          description: 'Connect to thousands of services for automation'
        },
        {
          name: 'Scene Trigger',
          description: 'Activate multi-device scenes from button'
        },
        {
          name: 'Automation',
          description: 'Time-based and sensor-triggered control'
        }
      ],
      specifications: [
        { label: 'Color', value: 'Grey' },
        { label: 'Protocols', value: 'Zigbee 3.0' },
        { label: 'Max Load', value: '800W LED / 1500W incandescent' },
        { label: 'Neutral Wire', value: 'Not required' },
        { label: 'Standard', value: 'EU Type (round & square)' },
        { label: 'Voltage', value: '220-240V AC' },
        { label: 'Control Methods', value: 'Touch button, app, voice (Siri/Alexa/Google), IFTTT, scenes, automation' },
        { label: 'Hub Required', value: 'Yes (Zigbee 3.0 hub)' }
      ]
    },
    'smart-wall-switch-h1-triple-no-neutral': {
      id: 'smart-wall-switch-h1-triple-no-neutral',
      name: 'Smart Wall Switch H1 Triple (No Neutral)',
      image: wallSwitchH1TripleNeutral,
      hero: wallSwitchH1TripleNoNeutralHero,
      featureImages: [wallSwitchH1TripleNeutralFeature],
      description: 'Triple Gang Switch without Neutral Wire',
      fullDescription: 'Perfect for retrofit installations where neutral wire is not available. Control three circuits with smart features without rewiring your home. Ideal for upgrading traditional switches in older buildings.',
      features: [
        'No neutral wire needed',
        'Triple gang control',
        'Award-winning design',
        'Retrofit friendly',
        'Smart home integration',
        'Overheat protection'
      ],
      detailedFeatures: [
        {
          title: 'No Neutral Wire Installation',
          description: 'Specifically designed for homes without neutral wiring. Retrofit installation without complex rewiring - simply replace existing switches to gain smart functionality.'
        },
        {
          title: 'Triple Circuit Control',
          description: 'Control three independent lighting circuits from one switch panel. Perfect for hallways, multi-zone living spaces, or areas requiring separate lighting control.'
        },
        {
          title: '86mm Square Wall Box Compatible',
          description: 'Fits standard 86mm square wall boxes used worldwide. Professional appearance with flush-mount installation that integrates seamlessly.'
        },
        {
          title: 'Zigbee 3.0 Technology',
          description: 'Latest Zigbee 3.0 protocol ensures fast, stable, and energy-efficient smart home connectivity. Reliable wireless control with extended range and minimal power consumption.'
        },
        {
          title: 'Award-Winning Premium Design',
          description: 'Metal frame construction with clean, symmetrical design. Short button travel and responsive tactile feedback provide satisfying, durable operation.'
        },
        {
          title: 'Wireless Switch Conversion',
          description: 'Remap physical buttons to trigger scenes or control other devices while lights are managed by automations. Transform buttons into wireless scene controllers.'
        },
        {
          title: 'Enhanced Safety Features',
          description: 'Built-in overheat protection ensures safe operation. Passed all necessary certifications including compatibility with highest safety standards.'
        },
        {
          title: 'Configurable LED & Power Memory',
          description: 'Customize LED indicator behavior - turn off completely, illuminate when on, or reverse. Configure power-off memory to control whether lights turn on after power restoration.'
        }
      ],
      accessMethods: [
        {
          name: 'Physical Rocker Buttons',
          description: 'Three independent buttons for direct control of each lighting circuit'
        },
        {
          name: 'Aqara Home App',
          description: 'Remote control and individual channel management via mobile app'
        },
        {
          name: 'Apple HomeKit',
          description: 'Full integration with Apple Home app and Siri voice commands'
        },
        {
          name: 'Google Assistant',
          description: 'Voice control through Google Home devices and app'
        },
        {
          name: 'Amazon Alexa',
          description: 'Hands-free operation via Alexa-enabled devices'
        },
        {
          name: 'Smart Automation',
          description: 'Motion sensor triggers, scheduling, and condition-based control'
        },
        {
          name: 'Scene Triggers',
          description: 'Activate multi-device scenes with button presses'
        },
        {
          name: 'IFTTT Integration',
          description: 'Connect to thousands of services for advanced automation'
        }
      ],
      specifications: [
        { label: 'Gangs', value: '3' },
        { label: 'Protocols', value: 'Zigbee 3.0' },
        { label: 'Max Load', value: '600W per channel' },
        { label: 'Neutral Wire', value: 'Not required' },
        { label: 'Installation', value: '86mm square wall box' },
        { label: 'Control Methods', value: 'Physical buttons (3), app, voice (Siri/Alexa/Google), automation, scenes' },
        { label: 'Protection', value: 'Overheat protection' },
        { label: 'Hub Required', value: 'Yes (Zigbee 3.0 hub)' }
      ]
    },
    'panel-switch-s100': {
      id: 'panel-switch-s100',
      name: 'Panel Switch S100',
      image: panelSwitchS100,
      hero: panelSwitchS100Hero,
      featureImages: [panelSwitchS100Feature],
      description: 'Smart Home Control Panel',
      fullDescription: 'The S100 combines beautiful design with powerful functionality. Its sleek touch panel interface provides intuitive control over your smart home devices with customizable themes and multi-function buttons.',
      features: [
        'Elegant touch panel',
        'Multi-function buttons',
        'Customizable themes',
        'Scene activation',
        'Status indicators',
        'Premium glass surface'
      ],
      detailedFeatures: [
        {
          title: 'Elegant Touch Panel Design',
          description: 'Premium tempered glass surface with capacitive touch technology provides responsive, precise control. Modern aesthetic complements any interior design style.'
        },
        {
          title: 'Multi-Function Control Buttons',
          description: 'Configure buttons for different devices, scenes, or automation triggers. Each button can control multiple functions based on press duration or combination.'
        },
        {
          title: 'Customizable Interface Themes',
          description: 'Personalize the panel appearance with multiple theme options. Adjust colors, layouts, and button arrangements to match your preference and home style.'
        },
        {
          title: 'One-Touch Scene Activation',
          description: 'Trigger complex multi-device scenes with single button press. Create custom scenes for different times of day or activities.'
        },
        {
          title: 'Smart Status Indicators',
          description: 'LED indicators provide instant visual feedback on device states. Backlit buttons ensure easy operation in any lighting condition.'
        },
        {
          title: 'Premium Build Quality',
          description: 'Constructed with tempered glass and high-quality materials for durability. Scratch-resistant surface maintains elegant appearance over time.'
        },
        {
          title: 'Smart Home Integration',
          description: 'Works seamlessly with Aqara ecosystem and major smart home platforms. Control lights, climate, security, and entertainment from one elegant panel.'
        },
        {
          title: 'Easy Installation & Configuration',
          description: 'Standard wall box mounting with simple setup process. Configure all functions via Aqara Home app without complex programming.'
        }
      ],
      accessMethods: [
        {
          name: 'Touch Panel Buttons',
          description: 'Capacitive touch buttons for direct device control'
        },
        {
          name: 'Scene Buttons',
          description: 'Programmable buttons for instant scene activation'
        },
        {
          name: 'Aqara Home App',
          description: 'Remote configuration and control via mobile application'
        },
        {
          name: 'Voice Assistants',
          description: 'Integration with Siri, Alexa, and Google Assistant'
        },
        {
          name: 'Automation',
          description: 'Time-based, sensor-triggered, and condition-based control'
        },
        {
          name: 'Multi-Press Actions',
          description: 'Different functions for single, double, and long press'
        }
      ],
      specifications: [
        { label: 'Panel Type', value: 'Capacitive touch' },
        { label: 'Protocols', value: 'Zigbee 3.0' },
        { label: 'Max Load', value: '1000W' },
        { label: 'Material', value: 'Tempered glass' },
        { label: 'Control Methods', value: 'Touch buttons, scenes, app, voice, automation, multi-press' },
        { label: 'Customization', value: 'Multiple themes and layouts' },
        { label: 'Installation', value: 'Standard wall box' },
        { label: 'Hub Required', value: 'Yes (Zigbee 3.0 hub)' }
      ]
    },
    'magic-switch-s1e': {
      id: 'magic-switch-s1e',
      name: 'Magic Switch S1E',
      image: magicSwitchS1E,
      hero: magicSwitchS1EHero,
      featureImages: [magicSwitchS1EFeature],
      description: 'Versatile Smart Switch Solution',
      fullDescription: 'The Magic Switch S1E offers versatile control options for your smart home. Its innovative design allows for multiple control methods and easy scene management with flexible installation.',
      features: [
        'Multi-function control',
        'Wireless operation',
        'Colorful display',
        'Scene triggering',
        'Battery powered',
        'Portable design'
      ],
      detailedFeatures: [
        {
          title: 'Versatile Multi-Function Control',
          description: 'One device controls lights, scenes, devices, and automations. Centralized control point for your entire smart home ecosystem.'
        },
        {
          title: 'Colorful Touch Display',
          description: 'Vibrant color screen displays device status, weather, and custom widgets. Easy-to-read interface provides instant information at a glance.'
        },
        {
          title: 'Wireless Freedom',
          description: 'Battery-powered design eliminates wiring requirements. Place anywhere you need control without electrical modifications.'
        },
        {
          title: 'Scene Management',
          description: 'Create and trigger complex multi-device scenes with single tap. Program different scenes for various times of day or activities.'
        },
        {
          title: 'Flexible Installation',
          description: 'Multiple mounting options including magnetic attachment, adhesive backing, or wall mount. Portable design allows easy repositioning.'
        },
        {
          title: 'Extended Battery Life',
          description: 'Efficient power management provides up to 2 years of operation. Rechargeable via USB-C for convenience.'
        },
        {
          title: 'Smart Home Integration',
          description: 'Works with Zigbee 3.0 ecosystem and major smart home platforms. Control all compatible devices from one elegant interface.'
        },
        {
          title: 'Customizable Interface',
          description: 'Personalize display widgets, button functions, and color schemes. Tailor the experience to your specific needs and preferences.'
        }
      ],
      accessMethods: [
        {
          name: 'Touch Display',
          description: 'Direct touch control via color screen interface'
        },
        {
          name: 'Physical Buttons',
          description: 'Quick-access buttons for frequently used functions'
        },
        {
          name: 'Scene Buttons',
          description: 'Programmable shortcuts for instant scene activation'
        },
        {
          name: 'Aqara Home App',
          description: 'Remote configuration and control via mobile app'
        },
        {
          name: 'Voice Control',
          description: 'Integration with smart home voice assistants'
        },
        {
          name: 'Automation',
          description: 'Schedule and condition-based automated actions'
        }
      ],
      specifications: [
        { label: 'Protocols', value: 'Zigbee 3.0' },
        { label: 'Power', value: 'Battery / USB-C rechargeable' },
        { label: 'Battery Life', value: 'Up to 2 years' },
        { label: 'Display', value: 'Color touchscreen' },
        { label: 'Mounting', value: 'Magnetic / adhesive / wall mount' },
        { label: 'Control Methods', value: 'Touch display, buttons, scenes, app, voice, automation' },
        { label: 'Hub Required', value: 'Yes (Zigbee 3.0 hub)' }
      ]
    },
    'magicpad-s1-plus': {
      id: 'magicpad-s1-plus',
      name: 'MagicPad S1 Plus',
      image: magicpadS1Plus,
      hero: magicpadS1PlusHero,
      featureImages: [magicpadS1PlusFeature],
      description: 'Advanced Touch Control Panel',
      fullDescription: 'The MagicPad S1 Plus is an advanced touch control panel featuring a high-resolution display for managing your entire smart home from one elegant interface. Control multiple rooms, scenes, and devices effortlessly.',
      features: [
        'High-resolution touchscreen',
        'Multi-room control',
        'Scene management',
        'Climate control',
        'Intercom functionality',
        'Customizable dashboard'
      ],
      detailedFeatures: [
        {
          title: 'High-Resolution Touch Display',
          description: '4" IPS LCD provides crystal-clear visuals with vibrant colors and sharp text. Responsive touch interface ensures smooth, intuitive navigation through all functions.'
        },
        {
          title: 'Multi-Room Control Hub',
          description: 'Control devices across different rooms from one central panel. Quick-switch between rooms for efficient whole-home management.'
        },
        {
          title: 'Advanced Scene Management',
          description: 'Create, edit, and activate complex multi-device scenes. Program scenarios for morning routines, entertaining, sleeping, and away modes.'
        },
        {
          title: 'Integrated Climate Control',
          description: 'Adjust thermostats, view temperature/humidity readings, and manage HVAC settings directly from the panel. Real-time environmental monitoring.'
        },
        {
          title: 'Intercom Functionality',
          description: 'Built-in intercom capability allows communication with other Aqara devices or mobile apps. Two-way audio for security and convenience.'
        },
        {
          title: 'Customizable Dashboard',
          description: 'Personalize the interface with widgets, shortcuts, and layouts that match your lifestyle. Arrange controls for quickest access to frequently used features.'
        },
        {
          title: 'Multi-Protocol Support',
          description: 'Zigbee 3.0, Wi-Fi, and Bluetooth connectivity ensures compatibility with wide range of smart devices. Seamless integration with your ecosystem.'
        },
        {
          title: 'Always-On Display',
          description: 'AC-powered design provides constant availability without battery concerns. Adjustable brightness with automatic dimming for nighttime use.'
        }
      ],
      accessMethods: [
        {
          name: 'Touch Interface',
          description: '4" touchscreen for direct device and scene control'
        },
        {
          name: 'Widget Controls',
          description: 'Customizable dashboard widgets for quick access'
        },
        {
          name: 'Room Selection',
          description: 'Quick-switch between different room controls'
        },
        {
          name: 'Scene Activation',
          description: 'One-touch triggering of complex multi-device scenes'
        },
        {
          name: 'Aqara Home App',
          description: 'Remote management and configuration via mobile app'
        },
        {
          name: 'Voice Control',
          description: 'Integration with major voice assistant platforms'
        },
        {
          name: 'Intercom',
          description: 'Two-way communication with mobile devices'
        },
        {
          name: 'Automation',
          description: 'Scheduled and sensor-triggered automated control'
        }
      ],
      specifications: [
        { label: 'Display', value: '4" IPS LCD touchscreen' },
        { label: 'Protocols', value: 'Zigbee 3.0, Wi-Fi, Bluetooth' },
        { label: 'Power', value: 'AC 100-240V powered' },
        { label: 'Installation', value: 'Wall mount' },
        { label: 'Control Methods', value: 'Touch interface, widgets, scenes, app, voice, intercom, automation' },
        { label: 'Features', value: 'Multi-room control, climate control, customizable dashboard' },
        { label: 'Hub Capability', value: 'Acts as control center for smart home' }
      ]
    },
    'panel-hub-s1-plus': {
      id: 'panel-hub-s1-plus',
      name: 'Panel Hub S1 Plus',
      image: panelHubS1Plus,
      hero: panelHubS1PlusHero,
      featureImages: [panelHubS1PlusFeature],
      description: 'Central Control Panel with Built-in Hub',
      fullDescription: 'Combines a smart control panel with a built-in Zigbee hub. The S1 Plus serves as both your smart home control center and connectivity hub, supporting up to 128 devices.',
      features: [
        'Built-in Zigbee hub',
        '4" touch control panel',
        'Supports 128+ devices',
        'Scene automation',
        'Intercom support',
        'Central dashboard'
      ],
      detailedFeatures: [
        {
          title: 'Integrated Zigbee 3.0 Hub',
          description: 'Built-in hub eliminates need for separate gateway device. Supports up to 128 Zigbee devices for comprehensive smart home control.'
        },
        {
          title: 'Touch Control Dashboard',
          description: '4" LCD touchscreen provides centralized control interface. Navigate all smart home functions from one elegant wall-mounted panel.'
        },
        {
          title: 'Comprehensive Device Management',
          description: 'Monitor and control all connected devices from single interface. View device status, battery levels, and connection quality at a glance.'
        },
        {
          title: 'Advanced Scene Automation',
          description: 'Create complex automations involving multiple devices. Program scenes for different times, conditions, or manual triggers.'
        },
        {
          title: 'Intercom Functionality',
          description: 'Two-way audio communication with Aqara mobile app. Check in on home, communicate with family members, or respond to visitors.'
        },
        {
          title: 'Central Smart Home Dashboard',
          description: 'Customizable home screen displays most important information. Quick access to frequently used controls and real-time status updates.'
        },
        {
          title: 'Multi-Protocol Connectivity',
          description: 'Zigbee 3.0 and Wi-Fi support ensures compatibility with vast range of devices. Seamless integration with major smart home platforms.'
        },
        {
          title: 'Always-On Availability',
          description: 'AC-powered design provides constant operation without battery concerns. Adjustable brightness adapts to ambient lighting conditions.'
        }
      ],
      accessMethods: [
        {
          name: 'Touch Panel Control',
          description: '4" touchscreen for direct device and hub management'
        },
        {
          name: 'Hub Management',
          description: 'Add, remove, and configure connected Zigbee devices'
        },
        {
          name: 'Scene Control',
          description: 'One-touch activation of multi-device automations'
        },
        {
          name: 'Aqara Home App',
          description: 'Remote management via mobile application'
        },
        {
          name: 'Voice Assistants',
          description: 'Integration with HomeKit, Alexa, and Google Assistant'
        },
        {
          name: 'Intercom',
          description: 'Two-way communication with mobile devices'
        },
        {
          name: 'Automation',
          description: 'Time-based and condition-triggered automated control'
        }
      ],
      specifications: [
        { label: 'Display', value: '4" Touch LCD' },
        { label: 'Hub Support', value: 'Up to 128 devices' },
        { label: 'Protocols', value: 'Zigbee 3.0, Wi-Fi' },
        { label: 'Power', value: 'AC 100-240V' },
        { label: 'Control Methods', value: 'Touch panel, hub management, scenes, app, voice, intercom, automation' },
        { label: 'Installation', value: 'Wall mount' },
        { label: 'Features', value: 'Built-in hub, intercom, device management, customizable dashboard' }
      ]
    },
    'light-switch-h2-eu': {
      id: 'light-switch-h2-eu',
      name: 'Light Switch H2 EU',
      image: lightSwitchH2EU,
      hero: lightSwitchH2EUHero,
      featureImages: [lightSwitchH2EUFeature],
      description: 'European Matter-Certified Light Switch',
      fullDescription: 'The H2 EU is a Matter-certified smart light switch designed for the European market. Enjoy universal compatibility with all major smart home platforms including Apple Home, Google Home, and Amazon Alexa.',
      features: [
        'Matter protocol certified',
        'EU standard design',
        'Universal platform support',
        'Physical button control',
        'Energy monitoring',
        'Easy setup'
      ],
      detailedFeatures: [
        {
          title: 'Matter Protocol Certified',
          description: 'Fully certified Matter device ensures interoperability across all major smart home platforms. Future-proof your home with universal standard support.'
        },
        {
          title: 'Universal Platform Compatibility',
          description: 'Works seamlessly with Apple Home, Google Home, Amazon Alexa, SmartThings, and any Matter-compatible ecosystem. One switch for all platforms.'
        },
        {
          title: 'European Standard Design',
          description: 'Designed specifically for EU-type wall boxes and electrical standards. Complies with European safety regulations and voltage requirements.'
        },
        {
          title: 'Physical Button Control',
          description: 'Traditional rocker-style button provides reliable manual control. Tactile feedback ensures confident operation even without looking.'
        },
        {
          title: 'Energy Monitoring',
          description: 'Track power consumption in real-time and view historical usage data. Identify energy-hungry devices and optimize usage for savings.'
        },
        {
          title: 'Thread Network Support',
          description: 'Matter over Thread protocol provides robust mesh networking. Self-healing network ensures reliable communication even with challenging layouts.'
        },
        {
          title: 'Simple Setup Process',
          description: 'Matter standard enables quick pairing with any compatible platform. Scan QR code and add to your preferred ecosystem in seconds.'
        },
        {
          title: 'LED Status Indicator',
          description: 'Configurable LED provides visual feedback on switch state. Adjust behavior via app to suit your preference.'
        }
      ],
      accessMethods: [
        {
          name: 'Physical Rocker',
          description: 'Manual on/off control via traditional rocker button'
        },
        {
          name: 'Apple Home',
          description: 'Native Matter integration with Apple Home and Siri'
        },
        {
          name: 'Google Home',
          description: 'Full control via Google Home app and Assistant'
        },
        {
          name: 'Amazon Alexa',
          description: 'Voice and app control through Alexa ecosystem'
        },
        {
          name: 'SmartThings',
          description: 'Integration with Samsung SmartThings platform'
        },
        {
          name: 'Any Matter App',
          description: 'Works with any Matter-compatible smart home application'
        },
        {
          name: 'Automation',
          description: 'Schedule and condition-based automated control'
        }
      ],
      specifications: [
        { label: 'Protocols', value: 'Matter, Thread' },
        { label: 'Standard', value: 'EU Type' },
        { label: 'Max Load', value: '800W LED' },
        { label: 'Voltage', value: '220-240V AC' },
        { label: 'Control Methods', value: 'Physical button, Matter platforms (Apple/Google/Alexa/Samsung/any), automation' },
        { label: 'Energy Monitoring', value: 'Yes' },
        { label: 'Hub Required', value: 'No (Matter over Thread)' }
      ]
    },
    'display-switch-v1-eu': {
      id: 'display-switch-v1-eu',
      name: 'Display Switch V1 EU',
      image: displaySwitchV1EU,
      hero: displaySwitchV1EUHero,
      featureImages: [displaySwitchV1EUFeature],
      description: 'Touch Display Smart Switch',
      fullDescription: 'A smart switch featuring an integrated display for status information and touch controls. See your home status at a glance and control devices with simple touch gestures.',
      features: [
        'Integrated status display',
        'Touch controls',
        'Real-time information',
        'Scene shortcuts',
        'Temperature display',
        'Modern design'
      ],
      detailedFeatures: [
        {
          title: 'Integrated Status Display',
          description: 'LCD status screen shows real-time information about devices, temperature, and system status. Always-on display provides instant visibility of home conditions.'
        },
        {
          title: 'Touch Control Interface',
          description: 'Responsive touch buttons provide modern, hygienic control without mechanical wear. Smooth operation with instant feedback for confident control.'
        },
        {
          title: 'Real-Time Information Display',
          description: 'View temperature, humidity, device states, and scene status at a glance. Stay informed about your smart home without opening any apps.'
        },
        {
          title: 'Quick Scene Shortcuts',
          description: 'Program frequently used scenes for one-touch activation. Access complex automations instantly from the switch face.'
        },
        {
          title: 'Environmental Monitoring',
          description: 'Built-in sensors display current temperature and humidity. Monitor room conditions directly from the switch for comfort management.'
        },
        {
          title: 'Modern Minimalist Design',
          description: 'Clean aesthetic with flush-mount design integrates seamlessly with contemporary interiors. Premium materials ensure lasting beauty.'
        },
        {
          title: 'High-Load Capacity',
          description: 'Supports up to 1000W of connected lighting or devices. Robust design handles demanding loads with reliable performance.'
        },
        {
          title: 'Smart Home Integration',
          description: 'Zigbee 3.0 connectivity works with Aqara ecosystem and major platforms. Voice control and app management for complete flexibility.'
        }
      ],
      accessMethods: [
        {
          name: 'Touch Buttons',
          description: 'Direct touch control via integrated display buttons'
        },
        {
          name: 'Scene Shortcuts',
          description: 'One-touch scene activation from switch face'
        },
        {
          name: 'Status Display',
          description: 'View real-time device and environmental information'
        },
        {
          name: 'Aqara Home App',
          description: 'Remote control and configuration via mobile app'
        },
        {
          name: 'Voice Control',
          description: 'Integration with Siri, Alexa, and Google Assistant'
        },
        {
          name: 'Automation',
          description: 'Time-based and sensor-triggered automated operation'
        }
      ],
      specifications: [
        { label: 'Display', value: 'LCD status screen' },
        { label: 'Protocols', value: 'Zigbee 3.0' },
        { label: 'Max Load', value: '1000W' },
        { label: 'Standard', value: 'EU Type' },
        { label: 'Control Methods', value: 'Touch display, scenes, app, voice, automation' },
        { label: 'Sensors', value: 'Temperature, humidity' },
        { label: 'Hub Required', value: 'Yes (Zigbee 3.0 hub)' }
      ]
    },
    'wireless-remote-switch-h1': {
      id: 'wireless-remote-switch-h1',
      name: 'Wireless Remote Switch H1',
      image: wirelessRemoteSwitchH1,
      hero: wirelessRemoteSwitchH1Hero,
      featureImages: [wirelessRemoteSwitchH1Feature],
      description: 'Battery-Powered Wireless Control',
      fullDescription: 'A flexible wireless switch that can be placed anywhere without wiring. Battery-powered design provides convenient smart control wherever you need it with up to 5 years of battery life.',
      features: [
        'No wiring required',
        '5-year battery life',
        'High-speed click mode',
        'Multiple button actions',
        'Flexible installation',
        '2-way setup support'
      ],
      detailedFeatures: [
        {
          title: 'Completely Wireless Freedom',
          description: 'Place anywhere without wiring requirements. Control any Zigbee 3.0 devices even when internet or hub connection goes down, thanks to direct device binding capability.'
        },
        {
          title: 'Zigbee 3.0 Protocol',
          description: 'Enjoy the fastest, most stable, and energy-efficient smart home technology. Reliable wireless connectivity with extended range and minimal power consumption for years of operation.'
        },
        {
          title: 'Exceptional 5-Year Battery Life',
          description: 'Ultra-low power consumption enables up to 5 years of operation on included batteries. No frequent battery changes or maintenance required.'
        },
        {
          title: 'High-Speed Click Mode',
          description: 'Toggle between multi-function mode (7 control actions) and high-speed click mode with nearly instantaneous 50ms response time for seamless, lag-free control.'
        },
        {
          title: 'Multiple Configurable Actions',
          description: 'Program different actions for single click, double click, long press, and simultaneous 2-button press. Up to 7 distinct control actions from one switch in multi-function mode.'
        },
        {
          title: 'Flexible Installation Options',
          description: 'Place directly on surfaces, stick using included adhesive pad, or screw into existing wall box. Portable design allows easy repositioning as needs change.'
        },
        {
          title: 'Award-Winning Design',
          description: 'Premium design shared with Wall Switch H1 EU provides high-end feel and durable construction. Clean aesthetic complements any interior style.'
        },
        {
          title: '2-Way Switch Setup Support',
          description: 'Pair with Wall Switch H1 EU to create 2-way switch functionality. Control lights from two locations with 5-year battery life - no wiring between switches required.'
        }
      ],
      accessMethods: [
        {
          name: 'Single Click',
          description: 'Quick press for primary action (on/off, scene activation)'
        },
        {
          name: 'Double Click',
          description: 'Two quick presses for secondary function'
        },
        {
          name: 'Long Press',
          description: 'Hold button for dimming or alternative action'
        },
        {
          name: 'Simultaneous Press',
          description: 'Press both buttons together for scene or group control'
        },
        {
          name: 'High-Speed Mode',
          description: '50ms response single-click mode for lag-free control'
        },
        {
          name: 'App Programming',
          description: 'Configure actions and bindings via Aqara Home app'
        },
        {
          name: 'Direct Device Binding',
          description: 'Control devices directly without hub dependency'
        },
        {
          name: 'Scene Triggering',
          description: 'Activate complex multi-device scenes with button press'
        }
      ],
      specifications: [
        { label: 'Protocols', value: 'Zigbee 3.0' },
        { label: 'Battery', value: 'CR2032 (included)' },
        { label: 'Battery Life', value: 'Up to 5 years' },
        { label: 'Buttons', value: '1/2/3 gang options' },
        { label: 'Response Time', value: '50ms (high-speed mode)' },
        { label: 'Control Actions', value: 'Up to 7 programmable actions' },
        { label: 'Installation', value: 'Adhesive, screw mount, or freestanding' },
        { label: 'Hub Required', value: 'Yes (for automations), No (for direct binding)' }
      ]
    },

    // Smart Camera Products
    'doorbell-camera-hub-g410': {
      id: 'doorbell-camera-hub-g410',
      name: 'Doorbell Camera Hub G410',
      image: doorbellG410,
      description: 'The Smartest Way to Say Hello',
      fullDescription: 'Premium video doorbell with built-in Zigbee hub. See, hear, and speak to visitors from anywhere with 2K+ resolution and advanced AI detection.',
      features: [
        '2K+ resolution (2304x1296)',
        'Built-in Zigbee hub',
        'Person/package detection',
        'Two-way audio',
        'Night vision',
        'Local storage support'
      ],
      specifications: [
        { label: 'Resolution', value: '2K+ (2304x1296)' },
        { label: 'Field of View', value: '162° ultra-wide' },
        { label: 'Power', value: 'Wired or battery' },
        { label: 'Storage', value: 'Local microSD + cloud' }
      ]
    },
    'camera-g100': {
      id: 'camera-g100',
      name: 'Camera G100',
      image: cameraG100,
      description: 'Secure Inside and Out',
      fullDescription: 'Versatile indoor/outdoor camera with weatherproof design. Monitor your home from anywhere with crystal-clear 2K video and intelligent alerts.',
      features: [
        '2K resolution',
        'Weatherproof (IP65)',
        'Color night vision',
        'AI person detection',
        'Two-way audio',
        'Matter support'
      ],
      specifications: [
        { label: 'Resolution', value: '2K (2304x1296)' },
        { label: 'IP Rating', value: 'IP65' },
        { label: 'Protocols', value: 'Matter, Wi-Fi' },
        { label: 'Storage', value: 'MicroSD + cloud' }
      ]
    },
    'camera-protect-kit-y100': {
      id: 'camera-protect-kit-y100',
      name: 'Camera Protect Kit Y100',
      image: cameraY100,
      description: 'Unparalleled Smart Home Security Plan',
      fullDescription: 'Complete security system with battery-powered camera and hub. Wire-free installation with 6-month battery life and comprehensive protection.',
      features: [
        'Wire-free design',
        '6-month battery life',
        'AI detection',
        'Included hub',
        'Cloud recording',
        'Easy installation'
      ],
      specifications: [
        { label: 'Resolution', value: '1080p Full HD' },
        { label: 'Battery', value: 'Rechargeable, 6-month life' },
        { label: 'Included', value: 'Camera + Hub' },
        { label: 'Field of View', value: '120°' }
      ]
    },
    'camera-hub-g5-pro': {
      id: 'camera-hub-g5-pro',
      name: 'Camera Hub G5 Pro',
      image: cameraG5Pro,
      description: 'Clearly Capturing the Unexpected, Day and Night',
      fullDescription: 'Professional security camera with built-in Zigbee hub. 2K resolution, color night vision, and local AI processing for privacy-focused monitoring.',
      features: [
        '2K QHD resolution',
        'Color night vision',
        'Built-in Zigbee hub',
        'Local AI processing',
        '360° pan, 140° tilt',
        'Privacy shutter'
      ],
      specifications: [
        { label: 'Resolution', value: '2K QHD (2304x1296)' },
        { label: 'Night Vision', value: 'Color + IR' },
        { label: 'Protocols', value: 'Zigbee 3.0, Wi-Fi' },
        { label: 'Storage', value: 'MicroSD up to 512GB' }
      ]
    },
    'camera-e1': {
      id: 'camera-e1',
      name: 'Camera E1',
      image: cameraE1,
      description: 'Smart Vision for a Safer Home',
      fullDescription: 'Affordable 2K security camera with essential smart features. Monitor your home with AI detection, night vision, and two-way communication.',
      features: [
        '2K resolution',
        'AI detection',
        'Pan & Tilt',
        'Night vision',
        'Two-way audio',
        'MicroSD storage'
      ],
      specifications: [
        { label: 'Resolution', value: '2K (2304x1296)' },
        { label: 'Pan/Tilt', value: '360°/140°' },
        { label: 'Connectivity', value: 'Wi-Fi 2.4GHz' },
        { label: 'Storage', value: 'MicroSD up to 256GB' }
      ]
    },
    'smart-video-doorbell-g4': {
      id: 'smart-video-doorbell-g4',
      name: 'Smart Video Doorbell G4',
      image: doorbellG4,
      description: 'Always Around, Even When You\'re Not',
      fullDescription: 'Smart doorbell with 1080p video, AI detection, and dual power options. See and speak to visitors whether you\'re home or away.',
      features: [
        '1080p Full HD',
        'Person detection',
        'Two-way audio',
        'Dual power options',
        'Night vision',
        'Chime support'
      ],
      specifications: [
        { label: 'Resolution', value: '1080p Full HD' },
        { label: 'Field of View', value: '162°' },
        { label: 'Power', value: 'Wired or battery' },
        { label: 'Protocols', value: 'Zigbee 3.0' }
      ]
    },

    // Smart Lighting Products
    'led-bulb-t2': {
      id: 'led-bulb-t2',
      name: 'LED Bulb T2',
      image: ledBulbT2,
      description: 'Tunable White Smart Bulb',
      fullDescription: 'Premium smart bulb with tunable white temperature. Adjust from warm to cool light to match your mood and activities throughout the day.',
      features: [
        'Tunable white (2700-6500K)',
        'Dimmable (1-100%)',
        'Energy efficient',
        'Long lifespan (25,000 hours)',
        'Voice control ready',
        'Scene integration'
      ],
      specifications: [
        { label: 'Color Temperature', value: '2700-6500K' },
        { label: 'Brightness', value: '806 lumens' },
        { label: 'Power', value: '9W' },
        { label: 'Protocols', value: 'Zigbee 3.0' }
      ]
    },
    'led-strip-t1': {
      id: 'led-strip-t1',
      name: 'LED Strip T1',
      image: ledStripT1,
      description: 'Flexible RGB+W LED Strip',
      fullDescription: 'Versatile RGB+W LED strip for ambient lighting. Cut to length, stick anywhere, and create stunning lighting effects in your home.',
      features: [
        'RGB + Warm White',
        '16 million colors',
        'Music sync mode',
        'Adhesive backing',
        'Cuttable design',
        'Linkable strips'
      ],
      specifications: [
        { label: 'Length', value: '2m (extendable to 10m)' },
        { label: 'LED Count', value: '60 LEDs/meter' },
        { label: 'Power', value: '12W' },
        { label: 'Protocols', value: 'Zigbee 3.0' }
      ]
    },
    'led-bulb-t1': {
      id: 'led-bulb-t1',
      name: 'LED Bulb T1',
      image: ledBulbT1,
      description: 'Energy Efficient Smart Bulb',
      fullDescription: 'Affordable smart bulb with essential features. Dimmable warm white light with long lifespan and low power consumption.',
      features: [
        'Dimmable warm white',
        'Energy efficient',
        'Long lifespan',
        'Voice control',
        'Schedule and timers',
        'Group control'
      ],
      specifications: [
        { label: 'Color Temperature', value: '2700K warm white' },
        { label: 'Brightness', value: '806 lumens' },
        { label: 'Power', value: '8.5W' },
        { label: 'Lifespan', value: '25,000 hours' }
      ]
    },
    'ceiling-light-t1m': {
      id: 'ceiling-light-t1m',
      name: 'Ceiling Light T1M',
      image: ceilingT1M,
      description: 'Modern Smart Ceiling Light',
      fullDescription: 'Sleek ceiling light with tunable white and brightness control. Perfect for living rooms, bedrooms, and offices requiring comprehensive lighting.',
      features: [
        'Tunable white',
        'Fully dimmable',
        'Modern design',
        'Energy efficient',
        'Easy installation',
        'Remote control'
      ],
      specifications: [
        { label: 'Color Temperature', value: '2700-6500K' },
        { label: 'Brightness', value: '2400 lumens' },
        { label: 'Power', value: '28W' },
        { label: 'Size', value: '400mm diameter' }
      ]
    },
    'spotlight-t1': {
      id: 'spotlight-t1',
      name: 'Spotlight T1',
      image: spotlightT1,
      description: 'GU10 Smart Spotlight',
      fullDescription: 'Smart GU10 spotlight bulb perfect for accent lighting. Dimmable and tunable for creating the perfect atmosphere in any room.',
      features: [
        'GU10 fitting',
        'Tunable white',
        'Dimmable',
        'Directional lighting',
        'Energy efficient',
        'Voice control'
      ],
      specifications: [
        { label: 'Color Temperature', value: '2700-6500K' },
        { label: 'Brightness', value: '350 lumens' },
        { label: 'Power', value: '5W' },
        { label: 'Beam Angle', value: '36°' }
      ]
    },
    'led-bulb-tunable-white': {
      id: 'led-bulb-tunable-white',
      name: 'LED Bulb (Tunable White)',
      image: ledBulbTunableWhite,
      description: 'Tunable White Smart Bulb',
      fullDescription: 'Versatile smart bulb with adjustable white color temperature. Create the perfect lighting from warm candlelight to bright daylight.',
      features: [
        'Tunable white temperature',
        'Smooth dimming',
        'Energy efficient',
        'Long lifespan',
        'Voice control',
        'Schedule automation'
      ],
      specifications: [
        { label: 'Color Temperature', value: '2700-6500K' },
        { label: 'Brightness', value: '806 lumens' },
        { label: 'Power', value: '9W' },
        { label: 'Base', value: 'E27' }
      ]
    },
    'spotlight-t2-lite': {
      id: 'spotlight-t2-lite',
      name: 'Spotlight T2 Lite',
      image: spotlightT2Lite,
      description: 'Affordable Smart Spotlight',
      fullDescription: 'Entry-level smart spotlight with essential features. Perfect for adding smart lighting without breaking the budget.',
      features: [
        'Affordable price',
        'Dimmable',
        'Voice control',
        'App control',
        'Scene support',
        'Energy efficient'
      ],
      specifications: [
        { label: 'Color Temperature', value: '2700-6500K' },
        { label: 'Brightness', value: '350 lumens' },
        { label: 'Power', value: '5W' },
        { label: 'Fitting', value: 'GU10' }
      ]
    },
    'spotlight-t2-pro': {
      id: 'spotlight-t2-pro',
      name: 'Spotlight T2 Pro',
      image: spotlightT2Pro,
      description: 'Premium Smart Spotlight',
      fullDescription: 'Professional-grade smart spotlight with advanced features for demanding installations.',
      features: [
        'RGB + White',
        'High brightness',
        'Premium quality',
        'Professional grade',
        'Advanced features',
        'Matter support'
      ],
      specifications: [
        { label: 'Colors', value: 'RGB + Tunable White' },
        { label: 'Brightness', value: '450 lumens' },
        { label: 'Power', value: '6W' },
        { label: 'Protocols', value: 'Matter, Zigbee 3.0' }
      ]
    },
    'spotlight-v1': {
      id: 'spotlight-v1',
      name: 'Spotlight V1',
      image: spotlightV1,
      description: 'Classic Smart Spotlight',
      fullDescription: 'Original Aqara spotlight design with reliable performance for everyday lighting needs.',
      features: [
        'Classic design',
        'Reliable performance',
        'Dimmable',
        'Remote control',
        'Scene compatible',
        'Long lasting'
      ],
      specifications: [
        { label: 'Color Temperature', value: '2700-6500K' },
        { label: 'Brightness', value: '350 lumens' },
        { label: 'Power', value: '5W' },
        { label: 'Fitting', value: 'GU10' }
      ]
    },
    'track-floodlight-v1': {
      id: 'track-floodlight-v1',
      name: 'Track Floodlight V1',
      image: trackFloodlightV1,
      description: 'Track-Mounted Floodlight',
      fullDescription: 'Wide-angle floodlight for track lighting systems. Perfect for illuminating large areas with even light distribution.',
      features: [
        'Wide beam angle',
        'Track mounting',
        'Adjustable direction',
        'Dimmable',
        'Scene support',
        'Professional quality'
      ],
      specifications: [
        { label: 'Beam Angle', value: '60°' },
        { label: 'Brightness', value: '1200 lumens' },
        { label: 'Power', value: '15W' },
        { label: 'Mounting', value: 'Track system' }
      ]
    },
    'track-grille-light-v1': {
      id: 'track-grille-light-v1',
      name: 'Track Grille Light V1',
      image: trackGrilleV1,
      description: 'Track Grille Lighting',
      fullDescription: 'Multi-directional grille light for track systems. Provides focused lighting with adjustable angles.',
      features: [
        'Multi-directional',
        'Grille design',
        'Adjustable angles',
        'Dimmable',
        'Track compatible',
        'Modern aesthetic'
      ],
      specifications: [
        { label: 'Light Sources', value: '3 adjustable heads' },
        { label: 'Brightness', value: '900 lumens total' },
        { label: 'Power', value: '12W' },
        { label: 'Mounting', value: 'Track system' }
      ]
    },
    'track-spotlight-v1': {
      id: 'track-spotlight-v1',
      name: 'Track Spotlight V1',
      image: trackSpotlightV1,
      description: 'Track-Mounted Spotlight',
      fullDescription: 'Precision spotlight for track lighting installations. Direct light exactly where you need it.',
      features: [
        'Precision focus',
        'Track mounting',
        'Rotatable head',
        'Dimmable',
        'Scene ready',
        'Professional lighting'
      ],
      specifications: [
        { label: 'Beam Angle', value: '24°' },
        { label: 'Brightness', value: '600 lumens' },
        { label: 'Power', value: '8W' },
        { label: 'Mounting', value: 'Track system' }
      ]
    },

    // Smart Curtain Products
    'curtain-controller-c3': {
      id: 'curtain-controller-c3',
      name: 'Curtain Controller C3',
      image: curtainC3,
      description: 'Advanced Curtain Automation',
      fullDescription: 'The C3 brings intelligent automation to your curtains with precise motor control, scheduling, and smart home integration. Control your curtains with voice, app, or automation.',
      features: [
        'Quiet motor operation',
        'Smart scheduling',
        'Voice control support',
        'Light sensing automation',
        'App remote control',
        'Multiple curtain types support'
      ],
      specifications: [
        { label: 'Motor Type', value: 'DC brushless' },
        { label: 'Max Load', value: '12kg' },
        { label: 'Protocols', value: 'Zigbee 3.0, Wi-Fi' },
        { label: 'Power', value: 'USB-C rechargeable' }
      ]
    },
    'curtain-controller-sea': {
      id: 'curtain-controller-sea',
      name: 'Curtain Controller (SEA Version)',
      image: curtainSEA,
      description: 'Regional Curtain Control Solution',
      fullDescription: 'Specially designed for Southeast Asian markets with optimized features and compatibility for local curtain systems.',
      features: [
        'Regional optimization',
        'Local curtain compatibility',
        'Smart home integration',
        'Scheduling and timers',
        'Manual override',
        'Energy efficient'
      ],
      specifications: [
        { label: 'Region', value: 'Southeast Asia' },
        { label: 'Protocols', value: 'Zigbee 3.0' },
        { label: 'Power', value: 'Battery or USB' },
        { label: 'Compatibility', value: 'Various track types' }
      ]
    },
    'curtain-driver-e1-rod': {
      id: 'curtain-driver-e1-rod',
      name: 'Curtain Driver E1 (Rod Version)',
      image: curtainE1Rod,
      description: 'Perfect for Rod-style Curtains',
      fullDescription: 'Compact and powerful curtain driver designed specifically for curtain rod installations. Easy to install without modifying existing curtains.',
      features: [
        'Rod-specific design',
        'Easy installation',
        'Quiet operation',
        'Smart automation',
        'Voice control ready',
        'Long battery life'
      ],
      specifications: [
        { label: 'Type', value: 'Rod version' },
        { label: 'Max Load', value: '12kg' },
        { label: 'Battery Life', value: 'Up to 1 year' },
        { label: 'Protocols', value: 'Zigbee 3.0' }
      ]
    },
    'curtain-driver-e1-track': {
      id: 'curtain-driver-e1-track',
      name: 'Curtain Driver E1 (Track Version)',
      image: curtainE1Track,
      description: 'Ideal for Track Curtains',
      fullDescription: 'Specially engineered for track-mounted curtain systems. Provides smooth, silent operation with intelligent automation features.',
      features: [
        'Track-specific design',
        'Ultra-quiet motor',
        'Smart scheduling',
        'Light sensor integration',
        'Voice assistant compatible',
        'Rechargeable battery'
      ],
      specifications: [
        { label: 'Type', value: 'Track version' },
        { label: 'Max Load', value: '12kg' },
        { label: 'Battery Life', value: 'Up to 1 year' },
        { label: 'Charging', value: 'USB-C' }
      ]
    },
    'roller-shade-t1s': {
      id: 'roller-shade-t1s',
      name: 'Roller Shade Controller T1S',
      image: rollerT1S,
      description: 'Smart Roller Shade Control',
      fullDescription: 'Advanced controller for roller shades with precise positioning and smart automation. Perfect for managing sunlight and privacy throughout the day.',
      features: [
        'Precise position control',
        'Sunlight automation',
        'Temperature sensing',
        'Multiple shade support',
        'Scene integration',
        'Voice control'
      ],
      specifications: [
        { label: 'Type', value: 'Roller shade controller' },
        { label: 'Max Load', value: '6kg' },
        { label: 'Protocols', value: 'Zigbee 3.0, Thread' },
        { label: 'Power', value: 'Rechargeable battery' }
      ]
    },
    'roller-shade-e1': {
      id: 'roller-shade-e1',
      name: 'Roller Shade Driver E1',
      image: rollerE1,
      description: 'Compact Roller Shade Motor',
      fullDescription: 'Compact and efficient motor for roller shades. Easy installation with powerful performance for smooth and reliable operation.',
      features: [
        'Compact design',
        'Easy installation',
        'Quiet operation',
        'Smart automation',
        'App control',
        'Long battery life'
      ],
      specifications: [
        { label: 'Type', value: 'Roller shade motor' },
        { label: 'Max Load', value: '6kg' },
        { label: 'Battery Life', value: 'Up to 18 months' },
        { label: 'Protocols', value: 'Zigbee 3.0' }
      ]
    },
    'roller-shade-controller': {
      id: 'roller-shade-controller',
      name: 'Smart Roller Shade Controller',
      image: rollerController,
      description: 'Intelligent Shade Management',
      fullDescription: 'Comprehensive roller shade control system with advanced features for energy efficiency and comfort management.',
      features: [
        'Intelligent automation',
        'Energy saving modes',
        'Multi-room control',
        'Schedule programming',
        'Voice integration',
        'Remote access'
      ],
      specifications: [
        { label: 'Compatibility', value: 'Universal roller shades' },
        { label: 'Protocols', value: 'Zigbee 3.0, Wi-Fi' },
        { label: 'Power', value: 'AC adapter or battery' },
        { label: 'Control', value: 'App, voice, automation' }
      ]
    },

    // Keep existing legacy products for backwards compatibility
    'smart-hubs': {
      id: 'smart-hubs',
      name: 'Smart Hubs',
      image: hubsImg,
      description: 'Central devices that connect and control various smart home products, allowing them to work together seamlessly.',
      fullDescription: 'The smart hub is the brain of your smart home, connecting all your devices and enabling them to communicate with each other. Create automated routines and control everything from one place.',
      features: [
        'Multi-protocol support (Zigbee, Z-Wave, Wi-Fi)',
        'Voice assistant integration',
        'Scene and automation creation',
        'Energy monitoring',
        'Local and cloud processing',
        'Supports 100+ devices'
      ],
      specifications: [
        { label: 'Protocols', value: 'Zigbee 3.0, Z-Wave Plus, Wi-Fi' },
        { label: 'Processor', value: 'Quad-core ARM' },
        { label: 'Memory', value: '1GB RAM' },
        { label: 'Connectivity', value: 'Ethernet, Wi-Fi' }
      ]
    },
    'smart-switches': {
      id: 'smart-switches',
      name: 'Smart Switches',
      image: switchesImg,
      description: 'Replace standard light switches to control lighting and other connected devices with ease.',
      fullDescription: 'Transform your home lighting with smart switches that allow remote control, scheduling, and automation. No neutral wire required for most installations.',
      features: [
        'Voice control compatible',
        'Remote on/off control',
        'Scheduling and timers',
        'Energy monitoring',
        'No hub required',
        'Scene integration'
      ],
      specifications: [
        { label: 'Voltage', value: '110-240V AC' },
        { label: 'Load', value: 'Up to 1500W' },
        { label: 'Connectivity', value: 'Wi-Fi 2.4GHz' },
        { label: 'Installation', value: 'Single pole, 3-way' }
      ]
    },
    'smart-lights': {
      id: 'smart-lights',
      name: 'Smart Lights',
      image: bulbsImg,
      description: 'LED bulbs or fixtures that can be controlled remotely, allowing you to adjust brightness and color.',
      fullDescription: 'Create the perfect ambiance with smart lights featuring millions of colors, adjustable white tones, and intelligent automation. Energy-efficient LED technology ensures long-lasting performance.',
      features: [
        '16 million colors',
        'Adjustable brightness (1-100%)',
        'Tunable white (2700K-6500K)',
        'Music sync capability',
        'Scheduling and routines',
        'Group control'
      ],
      specifications: [
        { label: 'Wattage', value: '9W (60W equivalent)' },
        { label: 'Lumens', value: '800 lm' },
        { label: 'Lifespan', value: '25,000 hours' },
        { label: 'Base', value: 'E27/E26' }
      ]
    },
    'smart-sensors': {
      id: 'smart-sensors',
      name: 'Smart Sensors',
      image: sensorsImg,
      description: 'Devices that monitor various environmental factors such as motion, temperature, humidity, or air quality.',
      fullDescription: 'Keep your home safe and comfortable with intelligent sensors that detect motion, monitor temperature and humidity, and trigger automated responses.',
      features: [
        'Motion detection',
        'Temperature monitoring',
        'Humidity tracking',
        'Light level sensing',
        'Instant notifications',
        'Automation triggers'
      ],
      specifications: [
        { label: 'Detection Range', value: 'Up to 7 meters' },
        { label: 'Battery Life', value: 'Up to 2 years' },
        { label: 'Connectivity', value: 'Zigbee 3.0' },
        { label: 'Temperature Range', value: '-10°C to 50°C' }
      ]
    },
    'smart-cameras': {
      id: 'smart-cameras',
      name: 'Smart Cameras',
      image: camerasImg,
      description: 'A smart camera that also works as a Zigbee hub, compatible with Apple HomeKit Secure Video.',
      fullDescription: 'Keep an eye on your home with HD smart cameras featuring night vision, two-way audio, and intelligent motion detection. Secure video storage ensures your privacy.',
      features: [
        '1080p Full HD video',
        'Night vision up to 10m',
        'Two-way audio',
        'Person detection',
        'Cloud and local storage',
        'Activity zones'
      ],
      specifications: [
        { label: 'Resolution', value: '1920x1080 (Full HD)' },
        { label: 'Field of View', value: '130° diagonal' },
        { label: 'Connectivity', value: 'Wi-Fi 2.4/5GHz' },
        { label: 'Storage', value: 'Cloud & microSD' }
      ]
    },
    'smart-remotes': {
      id: 'smart-remotes',
      name: 'Smart Remotes',
      image: remotesImg,
      description: 'Universal remote controls that can operate multiple devices including TVs and sound systems.',
      fullDescription: 'Simplify your entertainment setup with a universal smart remote that controls all your devices. Customizable buttons and activities make operation effortless.',
      features: [
        'Controls 8+ devices',
        'Customizable buttons',
        'One-touch activities',
        'Voice control integration',
        'Backlit buttons',
        'Smartphone app'
      ],
      specifications: [
        { label: 'Battery', value: 'Rechargeable Li-ion' },
        { label: 'Battery Life', value: '3 months per charge' },
        { label: 'Connectivity', value: 'IR, Wi-Fi, Bluetooth' },
        { label: 'Range', value: 'Up to 15 meters' }
      ]
    },
    'smart-speakers': {
      id: 'smart-speakers',
      name: 'Smart Speakers',
      image: speakersImg,
      description: 'Voice-activated devices that can play music, answer questions, and control smart home devices.',
      fullDescription: 'Experience premium sound quality with voice-controlled smart speakers. Get answers, control your smart home, and enjoy your favorite music with simple voice commands.',
      features: [
        'Voice assistant built-in',
        '360° premium audio',
        'Multi-room audio',
        'Smart home control hub',
        'Music streaming services',
        'Hands-free calling'
      ],
      specifications: [
        { label: 'Audio', value: '2" woofer + 0.8" tweeter' },
        { label: 'Power Output', value: '10W' },
        { label: 'Connectivity', value: 'Wi-Fi, Bluetooth 5.0' },
        { label: 'Microphones', value: 'Far-field (4 array)' }
      ]
    }
  };

  const product = productId ? products[productId] : null;

  // Function to generate WhatsApp message with product details
  const generateWhatsAppLink = (product: Product) => {
    const message = `Hello! I'm interested in the following product from Aqara:\n\n📦 *Product:* ${product.name}\n📝 *Description:* ${product.description}\n\nCould you please provide me with more information about:\n- Pricing and availability\n- Technical specifications\n- Installation requirements\n- Warranty details\n\nThank you!`;
    
    const encodedMessage = encodeURIComponent(message);
    return `https://wa.me/+94774641111?text=${encodedMessage}`;
  };

  if (!product) {
    return (
      <>
        <Header />
        <div className="product-detail-container">
          <div className="not-found">
            <h1>Product Not Found</h1>
            <button onClick={() => navigate('/category/smart-home-hub')} className="back-btn">
              Back to Categories
            </button>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />
      <div className="product-detail-container">
        <button onClick={() => navigate(`/category/${getCategoryFromProductId(productId || '')}`)} className="back-btn">
          ← Back to Categories
        </button>

      <div className="product-detail-content">
        {product.hero || product.heroVideo ? (
          <div className={`product-hero-section ${productId}`}>
            <div className="product-hero-image-wrapper">
              {product.heroVideo ? (
                <video 
                  src={product.heroVideo} 
                  className="product-hero-image" 
                  autoPlay 
                  loop 
                  muted 
                  playsInline
                />
              ) : (
                <img src={product.hero} alt={`${product.name} Hero`} className="product-hero-image" />
              )}
            </div>
            <div className="product-hero-info">
              <h1>{product.name}</h1>
              <p className="product-short-description">{product.description}</p>
              <a href={generateWhatsAppLink(product)} target="_blank" rel="noopener noreferrer" className="whatsapp-btn">
                Contact Us on WhatsApp
              </a>
            </div>
          </div>
        ) : (
          <div className="product-detail-header">
            <div className="product-detail-image">
              <img src={product.image} alt={product.name} />
            </div>
            <div className="product-detail-info">
              <h1>{product.name}</h1>
              <p className="product-short-description">{product.description}</p>
              <a href={generateWhatsAppLink(product)} target="_blank" rel="noopener noreferrer" className="whatsapp-btn">
                Contact Us on WhatsApp
              </a>
            </div>
          </div>
        )}

        <div className="product-detail-body">
          <section className="product-section">
            <h2>About This Product</h2>
            <p>{product.fullDescription}</p>
          </section>

          {product.featureVideo && (
            <section className="product-section feature-video-section">
              <div className="feature-video-wrapper">
                <video 
                  src={product.featureVideo} 
                  className="feature-video" 
                  autoPlay 
                  loop 
                  muted 
                  playsInline
                />
              </div>
            </section>
          )}

          {product.featureImages && product.featureImages.length > 0 && (
            <section className="product-section feature-images-section">
              <div className="feature-images-grid">
                {product.featureImages.map((image, index) => (
                  <div key={index} className="feature-image-item">
                    <img src={image} alt={`${product.name} Feature ${index + 1}`} />
                  </div>
                ))}
              </div>
            </section>
          )}

          {product.contentSections && product.contentSections.length > 0 && (
            <>
              {product.contentSections.map((section, index) => (
                <section key={index} className="product-section content-section">
                  <div className="content-section-wrapper">
                    <div className="content-section-image">
                      <img src={section.image} alt={section.title} />
                    </div>
                    <div className="content-section-text">
                      <h2>{section.title}</h2>
                      <p>{section.description}</p>
                      {section.note && <p className="content-note">{section.note}</p>}
                    </div>
                  </div>
                </section>
              ))}
            </>
          )}

          <section className="product-section">
            <h2>Key Features</h2>
            <ul className="features-list">
              {product.features.map((feature, index) => (
                <li key={index}>{feature}</li>
              ))}
            </ul>
          </section>

          <section className="product-section">
            <h2>Technical Specifications</h2>
            <div className="specifications-grid">
              {product.specifications.map((spec, index) => (
                <div key={index} className="spec-item">
                  <span className="spec-label">{spec.label}:</span>
                  <span className="spec-value">{spec.value}</span>
                </div>
              ))}
            </div>
          </section>

          <section className="product-section cta-section">
            <h2>Ready to Upgrade Your Home?</h2>
            <p>Contact us today to learn more about this product and get a personalized quote.</p>
            <a href={generateWhatsAppLink(product)} target="_blank" rel="noopener noreferrer" className="cta-btn">
              Get Started
            </a>
          </section>
        </div>
      </div>
      </div>
      <Footer />
    </>
  );
};

export default ProductDetail;

